	<template>
		<div class="app-container">
			<!-- 顶部导航栏 -->
			<header class="header-nav">
				<div class="header-left">
					<span class="logo-icon">♈</span>
					<span class="system-name">白羊轨迹定制测试系统</span>
				</div>
				<div class="header-right">
					<div class="balance-item">
						<span class="balance-label">
							<i class="el-icon-coin" style="color: #FFD700;"></i>
						</span>
						<span ref="balanceValue" class="balance-value">{{ userBalance }}</span>
						<span class="balance-text">积分</span>
						<!-- 积分充值按钮 -->
						<el-button type="text" icon="el-icon-money" style="color:#67C23A !important;" class="record-btn"
							@click="handleRecharge" title="积分在线兑换"></el-button>
						<el-button type="text" icon="el-icon-refresh" class="refresh-btn" @click="refreshBalance"
							title="刷新余额"></el-button>
						<!-- 新增充值记录按钮 -->
						<el-button type="text" icon="el-icon-document" class="record-btn" @click="showRechargeDialog"
							title="查看积分兑换记录"></el-button>
					</div>
					<div class="user-info">
						<i class="el-icon-user user-icon"></i>
						<span class="phone-number">{{ userPhone }}</span>
					</div>
					<el-button type="text" icon="el-icon-switch-button" class="logout-btn" @click="handleLogout"
						title="退出登录">
						退出登录
					</el-button>
				</div>
			</header>

			<!-- 原有Home页面内容 -->
			<div class="home-container">
				<!-- 1. 顶部订单状态标签栏 -->
				<div class="status-tabs">
					<div v-for="item in statusList" :key="item.key" class="status-tab-item"
						:class="{ active: activeTab === item.key }" @click="handleStatusTabClick(item.key)"
						v-if="item.key !== '3' && item.key !== '5' && item.key !== '1' && item.key !== '2'">
						<!-- 隐藏待签收和已取消 -->
						<i :class="item.icon" :style="{ color: activeTab === item.key ? '#fff' : item.color }"></i>
						<span>{{ item.name }}</span>
						<!-- 修改：总是显示数量，即使为0 -->
						<span class="badge" :class="{ 'zero-count': item.count === 0 }">
							{{ item.count }}
						</span>
					</div>
				</div>

				<!-- 2，修改批量操作按钮栏的结构 -->
				<div class="batch-actions">
					<!-- 左边的批量操作按钮 -->
					<div class="batch-left">
						<el-button type="success" @click="handleRecharge">积分兑换</el-button>

						<el-button type="danger" icon="el-icon-delete" class="batch-btn cancel"
							:disabled="!batchButtons.cancel" @click="handleBatchCancel" v-if="false">
							批量取消({{ selectedOrderIds.length }})
						</el-button>
						<el-button type="primary" icon="el-icon-check" class="batch-btn confirm"
							:disabled="!batchButtons.confirm" @click="handleBatchConfirm" v-if="false">
							批量确认({{ selectedOrderIds.length }})
						</el-button>
						<el-button type="success" icon="el-icon-circle-check" class="batch-btn sign"
							:disabled="!batchButtons.sign" @click="handleBatchSign" v-if="false">
							批量签收({{ selectedOrderIds.length }})
						</el-button>
						<el-button type="default" icon="el-icon-download" class="batch-btn export" disabled v-if="false">
							批量导出({{ selectedOrderIds.length }})
						</el-button>
						<el-button type="default" icon="el-icon-download" class="batch-btn download" disabled v-if="false">
							批量下载面单({{ selectedOrderIds.length }})
						</el-button>

					</div>

					<!-- 右边的导入按钮 -->
					<div class="batch-right">
						<el-button type="default" icon="el-icon-upload" class="batch-btn import-order"
							@click="showImportOrderDialog">
							导入自动签收单
						</el-button>
						<el-button type="default" icon="el-icon-upload" class="batch-btn import-sign"
							@click="showImportManualSignDialog" disabled>
							导入手动签收单
						</el-button>
					</div>
				</div>

				<!-- 3. 搜索栏 -->
				<div class="search-bar">
					<div class="search-form">
						<!-- 商户订单号 -->
						<el-input v-model="searchForm.merchant_order_no" placeholder="商户订单号"
							class="search-input merchant-order-no" clearable prefix-icon="el-icon-document"></el-input>

						<!-- 服务商单号（物流单号） -->
						<el-input v-model="searchForm.track_number" placeholder="物流单号"
							class="search-input provider-order-no" clearable prefix-icon="el-icon-tickets"></el-input>

						<!-- 物流商选择器 -->
						<el-select v-model="searchForm.track_type" placeholder="物流商" class="search-input order-type"
							clearable>
							<el-option label="全部" :value="0"></el-option>
							<el-option label="（佳成）JCEX" :value="1"></el-option>
							<el-option label="（极速）JS" :value="2"></el-option>
							<el-option label="（小猪）PIGGY" :value="3"></el-option>
						</el-select>

						<!-- 订单状态（可选，默认通过标签栏控制） -->
						<!-- <el-select v-model="searchForm.order_status" placeholder="订单状态" class="search-input order-status"
							clearable>
							<el-option label="全部" :value="0"></el-option>
							<el-option label="待确认" :value="1"></el-option>
							<el-option label="手动签收单" :value="2"></el-option>
							<el-option label="待签收" :value="3"></el-option>
							<el-option label="已签收" :value="4"></el-option>
							<el-option label="已取消" :value="5"></el-option>
						</el-select> -->

						<!-- 订单创建时间范围（需要两个字段：开始和结束） -->
						<el-date-picker v-model="searchForm.create_time_start" type="datetime" placeholder="创建时间开始"
							clearable format="yyyy/MM/dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss"
							class="search-input create-time-start" prefix-icon="el-icon-date"></el-date-picker>

						<el-date-picker v-model="searchForm.create_time_end" type="datetime" placeholder="创建时间结束" clearable
							format="yyyy/MM/dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss"
							class="search-input create-time-end" prefix-icon="el-icon-date"></el-date-picker>

						<!-- 轨迹开始时间范围 -->
						<el-date-picker v-model="searchForm.track_start_time_start" type="datetime" placeholder="轨迹开始时间开始"
							clearable format="yyyy/MM/dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss"
							class="search-input track-start-time-start"></el-date-picker>

						<el-date-picker v-model="searchForm.track_start_time_end" type="datetime" placeholder="轨迹开始时间结束"
							clearable format="yyyy/MM/dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss"
							class="search-input track-start-time-end"></el-date-picker>
						<!-- 每页显示数量 - 普通输入框 -->
						<el-input v-model="pageSizeInput" placeholder="每页显示" class="search-input page-size-input"
							@keyup.enter="handleSearch" @input="handlePageSizeInput" clearable></el-input>
						<el-button @click="handleReset" class="reset-btn">
							重置
						</el-button>
						<el-button type="primary" @click="handleSearch" class="search-btn" icon="el-icon-search">
							搜索
						</el-button>

					</div>
				</div>

				<!-- 4. 订单表格 -->
				<div class="table-container">
					<el-table :data="orderTableData" border style="width: 100%" v-loading="tableLoading"
						class="order-table" :header-cell-style="{ 
								background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
								color: '#fff',
								fontWeight: '600',
								fontSize: '14px',
								padding: '12px 8px'
							}" :cell-style="{ 
								padding: '10px 8px',
								fontSize: '13px'
							}" @selection-change="handleSelectionChange">
						<!-- 添加选择列 -->
						<el-table-column type="selection" width="50" align="center">
						</el-table-column>

						<!-- 商户订单号 -->
						<el-table-column prop="merchantOrderNo" label="商户订单号" align="center" min-width="150">
							<template slot-scope="scope">
								<div class="simple-cell">
									<el-tooltip v-if="scope.row.merchantOrderNo && scope.row.merchantOrderNo.length > 12"
										:content="scope.row.merchantOrderNo" placement="top">
										<span class="cell-text">
											{{ scope.row.merchantOrderNo.substring(0, 12) }}...
										</span>
									</el-tooltip>
									<span v-else class="cell-text">
										{{ scope.row.merchantOrderNo || '-' }}
									</span>
								</div>
							</template>
						</el-table-column>

						<!-- 服务商单号 -->
						<el-table-column prop="providerOrderNo" label="服务商单号" align="center" min-width="160">
							<template slot-scope="scope">
								<div class="simple-cell">
									<span class="cell-text track-number">
										<a :href="getLinkUrl(scope.row.providerOrderNo)" target="_blank"
											rel="noopener noreferrer">
											{{ scope.row.providerOrderNo || '-' }}
										</a>
									</span>
								</div>
							</template>
						</el-table-column>

						<!-- 物流商 -->
						<el-table-column prop="orderType" label="物流商" align="center" min-width="100">
							<template slot-scope="scope">
								<el-tag :type="scope.row.orderType === '1' ? 'primary' : 'success'" effect="plain"
									size="small" style="border-radius: 4px; padding: 4px 8px;">
									{{ scope.row.orderType === '1' ? 'JCEX' : 'JS' }}
								</el-tag>
							</template>
						</el-table-column>

						<!-- 发货地址 -->
						<el-table-column prop="senderAddress" label="发货地址" align="center" min-width="180">
							<template slot-scope="scope">
								<div class="address-cell">
									<template v-if="scope.row.formattedSenderAddress">
										<div class="address-line">
											<span class="address-label">州：</span>
											<span
												class="address-value">{{ scope.row.formattedSenderAddress.state || '-' }}</span>
										</div>
										<div class="address-line">
											<span class="address-label">城市：</span>
											<span
												class="address-value">{{ scope.row.formattedSenderAddress.city || '-' }}</span>
										</div>
										<div class="address-line">
											<span class="address-label">地址：</span>
											<el-tooltip
												v-if="scope.row.formattedSenderAddress.address && scope.row.formattedSenderAddress.address.length > 15"
												:content="scope.row.formattedSenderAddress.address" placement="top">
												<span class="address-value">
													{{ scope.row.formattedSenderAddress.address.substring(0, 15) }}...
												</span>
											</el-tooltip>
											<span v-else class="address-value">
												{{ scope.row.formattedSenderAddress.address || '-' }}
											</span>
										</div>
										<div class="address-line">
											<span class="address-label">邮编：</span>
											<span
												class="address-value">{{ scope.row.formattedSenderAddress.zipcode || '-' }}</span>
										</div>
									</template>
									<template v-else>
										<span class="cell-text">{{ scope.row.senderAddress || '-' }}</span>
									</template>
								</div>
							</template>
						</el-table-column>

						<!-- 收货地址 -->
						<el-table-column prop="receiverAddress" label="收货地址" align="center" min-width="180">
							<template slot-scope="scope">
								<div class="address-cell">
									<template v-if="scope.row.formattedReceiverAddress">
										<div class="address-line">
											<span class="address-label">州：</span>
											<span
												class="address-value">{{ scope.row.formattedReceiverAddress.state || '-' }}</span>
										</div>
										<div class="address-line">
											<span class="address-label">城市：</span>
											<span
												class="address-value">{{ scope.row.formattedReceiverAddress.city || '-' }}</span>
										</div>
										<div class="address-line">
											<span class="address-label">地址：</span>
											<el-tooltip
												v-if="scope.row.formattedReceiverAddress.address && scope.row.formattedReceiverAddress.address.length > 15"
												:content="scope.row.formattedReceiverAddress.address" placement="top">
												<span class="address-value">
													{{ scope.row.formattedReceiverAddress.address.substring(0, 15) }}...
												</span>
											</el-tooltip>
											<span v-else class="address-value">
												{{ scope.row.formattedReceiverAddress.address || '-' }}
											</span>
										</div>
										<div class="address-line">
											<span class="address-label">邮编：</span>
											<span
												class="address-value">{{ scope.row.formattedReceiverAddress.zipcode || '-' }}</span>
										</div>
									</template>
									<template v-else>
										<span class="cell-text">{{ scope.row.receiverAddress || '-' }}</span>
									</template>
								</div>
							</template>
						</el-table-column>

						<!-- 状态 -->
						<el-table-column prop="status" label="单号类型" align="center" min-width="130">
							<template slot-scope="scope">
								<el-tag :type="getStatusTagType(scope.row.status)" effect="light" size="small"
									style="border-radius: 12px; padding: 4px 12px; font-weight: 500;">
									{{ getStatusText(scope.row.status) }}
								</el-tag>
							</template>
						</el-table-column>

						<!-- 订单创建时间 -->
						<el-table-column prop="createTime" label="订单创建时间" align="center" min-width="160">
							<template slot-scope="scope">
								<div class="simple-cell">
									<span class="cell-text">{{ scope.row.createTime || '-' }}</span>
								</div>
							</template>
						</el-table-column>

						<!-- 备注 -->
						<el-table-column prop="remark" label="备注" align="center" min-width="150">
							<template slot-scope="scope">
								<div class="simple-cell">
									<el-tooltip v-if="scope.row.remark && scope.row.remark.length > 10"
										:content="scope.row.remark" placement="top">
										<span class="cell-text remark">
											{{ scope.row.remark.substring(0, 10) }}...
										</span>
									</el-tooltip>
									<span v-else class="cell-text remark">
										{{ scope.row.remark || '无' }}
									</span>
								</div>
							</template>
						</el-table-column>

						<!-- 轨迹开始时间 -->
						<el-table-column prop="trackStartTime" label="轨迹开始时间" align="center" min-width="160">
							<template slot-scope="scope">
								<div class="simple-cell">
									<span class="cell-text">{{ scope.row.trackStartTime || '-' }}</span>
								</div>
							</template>
						</el-table-column>

						<!-- 轨迹结束时间 -->
						<el-table-column prop="trackEndTime" label="轨迹结束时间" align="center" min-width="160">
							<template slot-scope="scope">
								<div class="simple-cell">
									<span class="cell-text">{{ scope.row.trackEndTime || '-' }}</span>
								</div>
							</template>
						</el-table-column>
					</el-table>

					<!-- 5. 空数据提示 -->
					<div class="empty-data" v-if="orderTableData.length === 0 && !tableLoading">
						<i class="el-icon-document" style="font-size: 48px; color: #c0c4cc; margin-bottom: 16px;"></i>
						<p style="font-size: 16px; color: #909399; margin: 0;">暂无订单数据</p>
						<p style="font-size: 14px; color: #c0c4cc; margin: 8px 0 0 0;">请尝试修改搜索条件或导入订单</p>
					</div>
				</div>

				<!-- 分页控件 -->
				<div class="pagination-container">
					<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
						layout="total, prev, pager, next" :total="total" class="order-pagination">
					</el-pagination>
				</div>

				<!-- 页脚版权信息 -->
				<div class="footer-copyright">
					©2025 万网ERP智慧物流测试平台 v1.0.2
				</div>
			</div>

			<!-- 充值记录弹窗 -->
			<el-dialog title="积分兑换记录查询" :visible.sync="rechargeDialogVisible" width="800px" center class="recharge-dialog">
				<div class="dialog-content">
					<el-table :data="rechargeRecords" border style="width: 100%" v-loading="rechargeLoading"
						:header-cell-style="{ 
					        background: '#f5f7fa',
					        color: '#606266',
					        fontWeight: '600',
					        fontSize: '14px'
					    }">
						<el-table-column prop="order_id" label="订单号" align="center" min-width="180"></el-table-column>
						<el-table-column prop="amount" label="积分数量" align="center" min-width="120">
							<template slot-scope="scope">
								<span style="color: #00C48C; font-weight: 500;">+{{ scope.row.amount }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="time" label="时间" align="center" min-width="180"></el-table-column>
						<el-table-column prop="type" label="类型" align="center" min-width="100">
							<template slot-scope="scope">
								<el-tag :type="scope.row.recharge_type === 1 ? 'success' : 'primary'" size="small"
									effect="plain">
									{{ scope.row.type }}
								</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="pay_status" label="支付状态" align="center" min-width="120">
							<template slot-scope="scope">
								<el-tag :type="scope.row.pay_status === 1 ? 'success' : 
						             scope.row.pay_status === 2 ? 'danger' : 'warning'" size="small" effect="plain">
									{{ scope.row.pay_status === 1 ? '兑换成功' : 
						         scope.row.pay_status === 2 ? '支付失败' : '兑换失败' }}
								</el-tag>
							</template>
						</el-table-column>
					</el-table>

					<!-- 空数据提示 -->
					<div class="empty-recharge" v-if="rechargeRecords.length === 0 && !rechargeLoading">
						<i class="el-icon-document" style="font-size: 40px; color: #c0c4cc; margin-bottom: 12px;"></i>
						<p style="font-size: 14px; color: #909399; margin: 0;">暂无积分兑换记录</p>
					</div>

					<!-- 分页 -->
					<div class="recharge-pagination" v-if="rechargeRecords.length > 0">
						<el-pagination @size-change="handleRechargeSizeChange"
							@current-change="handleRechargeCurrentChange" :current-page="rechargeCurrentPage"
							:page-sizes="[5, 10, 20]" :page-size="rechargePageSize" layout="total" :total="rechargeTotal"
							small></el-pagination>
					</div>
				</div>

				<span slot="footer" class="dialog-footer">
					<el-button @click="rechargeDialogVisible = false" class="dialog-btn cancel-btn"
						style="margin-right: 80px;">关闭</el-button>
					<el-button type="primary" @click="refreshRechargeRecords" class="dialog-btn refresh-btn"
						:loading="rechargeLoading">刷新记录</el-button>
				</span>
			</el-dialog>
			<!-- 通用导入对话框 -->
			<el-dialog :title="getImportDialogTitle()" :visible.sync="importDialogVisible" width="600px" center
				class="import-common-dialog">
				<div class="import-content">
					<!-- 加载状态显示 -->
					<div v-if="excelLoading" class="excel-loading">
						<i class="el-icon-loading"></i>
						<p>正在读取Excel文件...</p>
					</div>
					<!-- 物流商选择 -->
					<div class="provider-select-section">
						<div class="section-label">
							<i class="el-icon-document-copy" style="color: #667eea; margin-right: 8px;"></i>
							选择物流商
						</div>
						<div class="section-content">
							<el-select v-model="selectedProvider" placeholder="请选择物流商" class="provider-select">
								<el-option v-for="option in providerOptions" :key="option.value" :label="option.label"
									:value="option.value" :disabled="option.disabled">
								</el-option>
							</el-select>
							<p class="select-tip">
								<i class="el-icon-info" style="color: #909399; margin-right: 4px;"></i>
								<span v-if="selectedProvider === 0">系统将随机分配物流商</span>
								<span v-else-if="selectedProvider === 1">所有订单将使用 jcex 物流商</span>
								<span v-else>所有订单将使用 js 物流商</span>
							</p>
						</div>
					</div>
					<!-- 物流线路选择 -->
					<div class="provider-select-section">
						<div class="section-label">
							<i class="el-icon-truck" style="color: #667eea; margin-right: 8px;"></i>
							选择物流线路
						</div>
						<div class="section-content">
							<el-select v-model="selectedLine" placeholder="请选择物流商" class="provider-select">
								<el-option v-for="option in LinesOptions" :key="option.value" :label="option.label"
									:value="option.value" :disabled="option.disabled">
								</el-option>
							</el-select>
						</div>
					</div>
					<!-- 使用须知！ -->
					<div class="note-card">
						<span style="font-size: 14px;color:red;font-weight: bold;">使用须知！</span>
						<p>1，轨迹开始时间和结束时间必须在上午9 - 下午19点之间。</p>
						<p>2，单号生成完成，生成轨迹大概需要30分钟左右，轨迹可在&nbsp;<el-link href="https://www.17track.net/zh-cn" target="_blank"
								type="primary">17TRACK平台</el-link>&nbsp;查询。</p>
						<p>3，轨迹开始时间和结束时间，不要填整点。例如：00:00，一定要真实一点。</p>
						<p>4，轨迹显示时间按照<span style="color: red;">“ 世界协调时时间 UTC+0 ”</span>来计算。</p>
						<p>4，物流时效必须要在1-15天内，否则无法生成轨迹（中国发货的除外）。</p>
					</div>
					<br />
					<br />
					<!-- 文件选择区域 -->
					<div class="file-upload-area" @click="triggerFileInput" v-if="!showExcelPreview || !selectedFile">
						<div class="upload-icon">
							<i class="el-icon-upload" style="font-size: 48px; color: #667eea;"></i>
						</div>
						<div class="upload-text">
							<p class="main-text">选择xls文件</p>
							<p class="sub-text">选择文件</p>
							<p class="file-name" v-if="selectedFileName">{{ selectedFileName }}</p>
							<p class="file-name" v-else>未选择任何文件</p>
						</div>
						<input type="file" ref="fileInput" style="display: none" accept=".xls,.xlsx"
							@change="handleFileSelect" />
					</div>
					<!-- 修改 Excel数据预览 部分，删除表格预览 -->
					<div v-if="showExcelPreview && excelPreviewData.length > 0" class="excel-preview-section">
						<div class="section-label">
							<i class="el-icon-view" style="color: #00C48C; margin-right: 8px;"></i>
							数据预览（共{{ excelPreviewData.length }}条有效记录）
						</div>

						<!-- 数据统计 - 简化版 -->
						<div class="stats-info" v-if="excelStatistics">
							<el-row :gutter="16">
								<el-col :span="8">
									<div class="stat-item">
										<div class="stat-value">{{ excelStatistics.total }}</div>
										<div class="stat-label">总订单数</div>
									</div>
								</el-col>
								<el-col :span="8">
									<div class="stat-item">
										<div class="stat-value">{{ excelStatistics.validDates }}</div>
										<div class="stat-label">有效日期</div>
									</div>
								</el-col>
								<el-col :span="8">
									<div class="stat-item">
										<div class="stat-value">{{ Object.keys(excelStatistics.byPlatform).length }}</div>
										<div class="stat-label">平台数</div>
									</div>
								</el-col>
							</el-row>

						</div>

						<!-- 移除表格预览部分 -->

						<!-- 操作按钮 -->
						<div class="preview-actions">
							<!-- 添加重新上传按钮 -->
							<el-button size="small" @click="closeExcelPreview" type="warning">
								<i class="el-icon-close"></i> 重新上传
							</el-button>
						</div>
					</div>
					<br />
					<!-- 文件信息 -->
					<div class="file-info">

						<p class="info-title">支持的格式：Excel (.xls, .xlsx)</p>
						<p class="info-desc">请确保文件包含以下列：</p>
						<ul class="column-list">
							<li>电商平台，商户订单号，收件人省份、收件人城市、收件人街道、收件人邮编，发件人省份、发件人城市、发件人街道、发件人邮编，轨迹开始时间、轨迹结束时间、备注</li>

						</ul>
						<!-- 根据类型显示不同提示 -->
						<p v-if="importDialogType === 'auto'" class="info-extra">
							<i class="el-icon-info" style="color: #00C48C;"></i>
							自动签收单：系统会自动处理签收确认
						</p>

						<p v-else class="info-extra">
							<i class="el-icon-info" style="color: #6B48FF;"></i>
							手动签收单：需要用户手动确认签收
						</p>

					</div>

					<!-- 下载模板 -->
					<div class="download-template">
						<el-link type="primary" icon="el-icon-download" @click="downloadTemplate" :underline="false">
							点击下载{{ importDialogType === 'auto' ? '自动' : '手动' }}签收单模板
						</el-link>
					</div>
				</div>

				<span slot="footer" class="dialog-footer">
					<el-button @click="importDialogVisible = false" class="dialog-btn cancel-btn"
						style="margin-right: 80px;">
						取消
					</el-button>
					<el-button type="primary" :disabled="!selectedFile" :loading="importLoading"
						class="dialog-btn import-btn" @click="handleImport">
						提交{{ importDialogType === 'auto' ? '自动' : '手动' }}签收单
					</el-button>
				</span>
			</el-dialog>
		</div>
	</template>

	<script>
		import {
			excelReader
		} from '../utils/excelReader.js'; // 根据你的项目路径调整
		export default {
			name: 'Home',
			data() {
				return {
					exportResult: null, // 导入结果数据
					// Excel文件读取相关
					excelData: null,
					paymentCountdownTimer: null, // 支付倒计时计时器
					exportResult: null, // 导入结果数据
					allExcelData: [], // 保存所有Excel数据
					excelLoading: false,
					showExcelPreview: false,
					excelPreviewData: [],
					excelStatistics: null,
					importDialogVisible: false,
					importDialogType: 'auto', // 'auto' 或 'manual'
					selectedFile: null,
					selectedFileName: '',
					importLoading: false,
					// 新增：物流商选择
					selectedProvider: 1, // 默认选择随机
					selectedLine: 0,

					// 物流商选项列表
					providerOptions: [{
							value: 0,
							label: '随机分配'
						},
						{
							value: 1,
							label: 'JCEX(佳成物流)'
						},
						{
							value: 2,
							label: 'JS(极速物流)',
							disabled: true
						},
						{
							value: 3,
							label: 'PIGGY(小猪快递)',
							disabled: true
						}
					],
					// 物流线路选择
					LinesOptions: [{
							value: 0,
							label: '美国 - 美国'
						},
						{
							value: 1,
							label: '英国 - 英国'
						},
						{
							value: 2,
							label: '加拿大 - 加拿大'
						},
						{
							value: 3,
							label: '中国 - 全球',
							disabled: true
						}
					],
					// 导入手动签收单相关数据
					initializing: false, // 新增：页面初始化状态
					initError: null, // 新增：初始化错误信息
					isRefreshingBalance: false,
					userBalance: this.getUserBalance(), //积分余额
					userId: this.getUserId(), // 新增：用户ID
					userType: this.getUserType(), // 新增：用户类型
					selectedOrderIds: [], // 选中的订单ID数组
					selectedOrders: [], // 新增：选中的订单对象数组
					pageSizeInput: '', // 空字符串，这样placeholder能显示
					// 添加状态映射
					statusConfig: {
						'1': {
							name: '待确认单',
							canCancel: true,
							canConfirm: true,
							canSign: false
						},
						'2': {
							name: '手动签收单',
							canCancel: false,
							canConfirm: false,
							canSign: true
						},
						'3': {
							name: '待签收',
							canCancel: false,
							canConfirm: false,
							canSign: true
						},
						'4': {
							name: '自动签收单',
							canCancel: false,
							canConfirm: false,
							canSign: false
						},
						'5': {
							name: '已取消',
							canCancel: false,
							canConfirm: false,
							canSign: false
						}
					},
					batchButtons: {
						cancel: false,
						confirm: false,
						sign: false
					},
					userPhone: this.getUserPhone(), //用户手机号
					cachedStatusData: null, // 新增：缓存状态统计的数据
					statusList: [{
							key: '0',
							name: '全部订单',
							icon: 'el-icon-menu',
							color: '#909399',
							count: 0
						},
						{
							key: '1',
							name: '待确认单',
							icon: 'el-icon-warning',
							color: '#FFB800',
							count: 0
						},
						{
							key: '2',
							name: '手动签收单',
							icon: 'el-icon-thumb',
							color: '#6B48FF',
							count: 0
						},
						{
							key: '3',
							name: '待签收',
							icon: 'el-icon-user',
							color: '#FF6B8A',
							count: 0
						},
						{
							key: '4',
							name: '自动签收单',
							icon: 'el-icon-success',
							color: '#00C48C',
							count: 0
						},
						{
							key: '5',
							name: '已取消',
							icon: 'el-icon-circle-close',
							color: '#FF4D4F',
							count: 0
						},
					],
					// 新增：用于存储各状态的实际数量
					orderStatusCounts: {
						total: 0,
						'1': 0, // 待确认单
						'2': 0, // 手动签收单
						'3': 0, // 待签收
						'4': 0, // 自动签收单
						'5': 0 // 已取消
					},
					activeTab: '0', // 默认选中全部订单
					// 修改后的搜索表单
					searchForm: {
						merchant_order_no: '', // 商户订单号 - 修改为下划线格式
						track_number: '', // 服务商单号（物流单号）- 修改字段名
						track_type: 0, // 物流商：0=全部，1=jcex，2=js
						order_status: 0, // 订单状态：0=全部，1=待确认单，2=手动签收单，3=待签收，4=已签收，5=已取消
						create_time_start: '', // 订单创建开始时间
						create_time_end: '', // 订单创建结束时间
						track_start_time_start: '', // 轨迹开始开始时间
						track_start_time_end: '', // 轨迹开始结束时间
						track_end_time_start: '', // 轨迹结束开始时间
						track_end_time_end: '' // 轨迹结束结束时间
					},
					tableLoading: false,
					orderTableData: [],
					currentPage: 1,
					pageSize: 10,
					total: 0,
					wxDialog: false,
					// 充值记录相关数据
					rechargeDialogVisible: false,
					rechargeLoading: false,
					rechargeRecords: [],
					rechargeCurrentPage: 1,
					rechargePageSize: 10,
					rechargeTotal: 0,

					// 导入订单相关数据
					selectedFile: null,
					selectedFileName: '',
					importLoading: false
				}
			},
			methods: {
				// 新增：获取对话框标题
				getImportDialogTitle() {
					const typeText = this.importDialogType === 'auto' ? '自动' : '手动';
					return `导入${typeText}签收单`;
				},

				// 下载模板（根据类型）
				async downloadTemplate(type = 'auto') {
					const templateName = type === 'auto' ?
						'自动签收单模板.xlsx' :
						'自动签收单模板.xlsx';
					const message = type === 'auto' ?
						'自动签收单模板' :
						'手动签收单模板';

					this.$message.info(`正在下载${message}...`);

					try {
						// 确保 SheetJS 库已加载
						await this.loadSheetJS();

						// 创建工作簿
						const wb = XLSX.utils.book_new();

						// 按照你提供的顺序创建工作表数据
						const wsData = [
							// 表头行 - 严格按照你提供的顺序
							['电商平台', '商户订单号', '备注', '轨迹开始时间', '轨迹结束时间',
								'收件人省份', '收件人城市', '收件人街道', '收件人国家二字码', '收件人邮编',
								'发件人省份', '发件人城市', '发件人街道', '发件人国家二字码', '发件人邮编'
							],

							// 示例数据行 - 按相同的列顺序
							['*（示例）亚马逊', 'ORDER2024001', '重要客户订单',
								'2024-01-01 08:21:00', '2024-01-05 18:42:00',
								'California', 'Los Angeles', '123 Main St', 'US', '90001',
								'New York', 'New York City', '456 Broadway', 'US', '10001'
							],

							// 可以添加更多示例行
							['*（示例）eBay', 'ORDER2024002', '普通订单',
								'2024-01-02 09:12:00', '2024-01-06 17:35:00',
								'Texas', 'Houston', '789 Oak Ave', 'US', '77001',
								'Florida', 'Miami', '101 Beach Blvd', 'US', '33101'
							],

							// 注释行（可选）
							['// 填写说明:', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
							['// 1. 电商平台：如亚马逊、eBay等', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
							['// 2. 国家二字码：如美国-US', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
							['// 3. 时间格式：YYYY-MM-DD HH:mm:ss', '', '', '', '', '', '', '', '', '', '', '', '', '', '']
						];

						const ws = XLSX.utils.aoa_to_sheet(wsData);
						XLSX.utils.book_append_sheet(wb, ws, '模板');

						// 设置列宽，按照你的列顺序
						const colWidths = [{
								wch: 15
							}, // 电商平台
							{
								wch: 20
							}, // 商户订单号
							{
								wch: 20
							}, // 备注
							{
								wch: 18
							}, // 轨迹开始时间
							{
								wch: 18
							}, // 轨迹结束时间
							{
								wch: 12
							}, // 收件人省份
							{
								wch: 12
							}, // 收件人城市
							{
								wch: 20
							}, // 收件人街道
							{
								wch: 10
							}, // 收件人国家二字码
							{
								wch: 10
							}, // 收件人邮编
							{
								wch: 12
							}, // 发件人省份
							{
								wch: 12
							}, // 发件人城市
							{
								wch: 20
							}, // 发件人街道
							{
								wch: 10
							}, // 发件人国家二字码
							{
								wch: 10
							} // 发件人邮编
						];
						ws['!cols'] = colWidths;

						// 设置列冻结（冻结表头行）
						ws['!freeze'] = {
							x: 0,
							y: 1
						};

						// 设置打印区域（如果有需要）
						ws['!print'] = {
							fitToPage: true,
							fitToWidth: 1,
							fitToHeight: 0
						};

						// 生成文件
						const wbout = XLSX.write(wb, {
							bookType: 'xlsx',
							type: 'array'
						});
						const blob = new Blob([wbout], {
							type: 'application/octet-stream'
						});
						const url = URL.createObjectURL(blob);

						const link = document.createElement('a');
						link.href = url;
						link.download = templateName;
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);

						URL.revokeObjectURL(url);
						this.$message.success(`${templateName}下载成功`);

					} catch (error) {
						console.error('下载模板失败:', error);
						this.$message.error('下载模板失败: ' + error.message);
					}
				},
				// 修改：触发文件选择
				triggerFileInput() {
					this.$refs.fileInput.click();
				},
				// 读取Excel文件
				async readExcelFile(file) {
					this.excelLoading = true;

					try {
						const excelData = await excelReader.readExcelFile(file);

						if (!excelData) {
							throw new Error('Excel数据为空');
						}

						const sheet = excelData.sheets[0];

						// 根据导入类型解析数据
						let parsedResult;
						if (this.importDialogType === 'auto') {
							parsedResult = excelReader.parseAutoSignOrdersWithValidation(sheet.data);
						} else {
							const validation = excelReader.validateData(sheet.data);
							parsedResult = {
								data: sheet.data,
								validation,
								originalCount: sheet.data.length,
								validCount: validation.validRows,
								invalidCount: validation.invalidRows
							};
						}

						// 保存所有解析后的数据到 allExcelData
						this.allExcelData = parsedResult.data || [];
						// 3. 如果有错误，显示验证结果并终止
						if (parsedResult.validation && !parsedResult.validation.isValid) {
							this.showValidationDialog(parsedResult.validation, file.name);
							// 只显示有效数据的预览
							if (parsedResult.data.length > 0) {
								this.excelData = excelData;
								this.excelPreviewData = parsedResult.data.slice(0, 10);
								this.excelStatistics = excelReader.getStatistics(parsedResult.data);
								this.showExcelPreview = true; // 显示预览
							}

							// 终止上传流程
							this.excelLoading = false;
							return;
						}

						// 4. 更新响应式数据
						this.excelData = excelData;
						this.excelPreviewData = parsedResult.data;
						this.excelStatistics = excelReader.getStatistics(parsedResult.data);
						this.showExcelPreview = true; // 成功读取后显示预览

					} catch (error) {
						console.error('读取Excel文件失败:', error);
						this.$message.error('读取Excel文件失败: ' + error.message);

						// 读取失败时隐藏预览
						this.showExcelPreview = false;
					} finally {
						this.excelLoading = false;
					}
				},

				// 显示验证错误的弹窗
				showValidationDialog(validationResult, fileName) {
					const errorCount = validationResult.errors ? validationResult.errors.length : 0;
					const warningCount = validationResult.warnings ? validationResult.warnings.length : 0;

					const errorHtml = `
								      <div class="validation-result">
								        <div class="summary">
								          <p><strong>文件: ${fileName}</strong></p>
								          <p>总行数: ${validationResult.totalRows || validationResult.originalCount}</p>
								          <p>有效行数: ${validationResult.validRows || validationResult.validCount}</p>
								          <p>错误行数: ${validationResult.invalidRows || validationResult.invalidCount}</p>
								          <p style="color: ${errorCount > 0 ? '#ff4d4f' : '#52c41a'}">
								            验证结果: ${errorCount > 0 ? '失败' : '通过'}
								          </p>
								        </div>
								    `;

					let errorsHtml = '';
					let warningsHtml = '';

					// 错误信息
					if (errorCount > 0) {
						errorsHtml = `
								        <div class="error-section">
								          <h4 style="color: #ff4d4f; margin-top: 15px;">
								            <i class="el-icon-error"></i> 发现 ${errorCount} 个错误
								          </h4>
								          <div class="error-list" style="max-height: 200px; overflow-y: auto; margin-top: 10px;">
								            ${validationResult.errors.slice(0, 20).map(error => `
  <div class="error-item" style="padding: 8px; border-bottom: 1px solid #f0f0f0;">
    <div style="color: #ff4d4f; font-weight: 500;">
      第 ${error.row+1} 行：{${error.field}} 有误
    </div>
    ${error.value ? `<div style="color: #666; font-size: 12px;">值: ${error.value}</div>` : ''}
  </div>
`).join('')}
								            ${errorCount > 20 ? `<div style="text-align: center; color: #999; padding: 10px;">... 还有 ${errorCount - 20} 个错误未显示</div>` : ''}
								          </div>
								        </div>
								      `;
					}
					// 警告信息
					if (warningCount > 0) {
						warningsHtml = `
								        <div class="warning-section">
								          <h4 style="color: #fa8c16; margin-top: 15px;">
								            <i class="el-icon-warning"></i> 发现 ${warningCount} 个警告
								          </h4>
								          <div class="warning-list" style="max-height: 150px; overflow-y: auto; margin-top: 10px;">
								            ${validationResult.warnings.slice(0, 10).map(warning => `
								              <div class="warning-item" style="padding: 8px; border-bottom: 1px solid #f0f0f0;">
								                <div style="color: #fa8c16;">${warning.message}</div>
								              </div>
								            `).join('')}
								            ${warningCount > 10 ? `<div style="text-align: center; color: #999; padding: 10px;">... 还有 ${warningCount - 10} 个警告未显示</div>` : ''}
								          </div>
								        </div>
								      `;
					}

					const fullHtml = errorHtml + errorsHtml + warningsHtml + '</div>';

					this.$confirm(fullHtml, '数据验证结果', {
						dangerouslyUseHTMLString: true,
						showCancelButton: false,
						confirmButtonText: errorCount > 0 ? '关闭并修复' : '继续导入',
						cancelButtonText: '取消',
						type: errorCount > 0 ? 'error' : 'warning',
						customClass: 'validation-dialog',
						closeOnClickModal: false,
						beforeClose: (action, instance, done) => {
							if (action === 'confirm') {
								if (errorCount > 0) {
									// 有错误时不允许继续
									this.$message.error('请修复数据错误后再重新上传');
									done();
									return false;
								}
							}
							done();
						}
					}).then(() => {
						if (errorCount === 0) {
							this.$message.success('数据验证通过，可以继续导入');
						}
					}).catch(() => {
						this.$message.info('已取消');
					});
				},
				// 关闭Excel预览，显示文件选择区域
				closeExcelPreview() {
					this.showExcelPreview = false;
					// 可以选择不清除数据，这样用户重新选择文件时可以快速恢复
					// this.excelPreviewData = [];
					// this.excelStatistics = null;
				},
				// 新增：统计选中订单的状态分布
				countSelectionByStatus(selection) {
					const statusCount = {
						'1': 0, // 待确认
						'2': 0, // 手动签收单
						'3': 0, // 待签收
						'4': 0, // 自动签收单
						'5': 0 // 已取消
					};

					selection.forEach(order => {
						const status = order.status;
						if (statusCount.hasOwnProperty(status)) {
							statusCount[status]++;
						}
					});

					return statusCount;
				},

				// 新增：根据状态分布更新按钮状态
				updateButtonsByStatusCount(statusCount) {
					// 初始化按钮状态
					let canCancel = true;
					let canConfirm = true;
					let canSign = true;

					// 检查每个状态的权限
					Object.keys(statusCount).forEach(status => {
						if (statusCount[status] > 0) {
							const config = this.statusConfig[status];
							if (config) {
								if (!config.canCancel) canCancel = false;
								if (!config.canConfirm) canConfirm = false;
								if (!config.canSign) canSign = false;
							}
						}
					});

					this.batchButtons = {
						cancel: canCancel,
						confirm: canConfirm,
						sign: canSign
					};
				},
				// 显示导入手动签收单弹窗
				showImportManualSignDialog() {
					this.importDialogType = 'manual';
					this.importDialogVisible = true;
					// 打开弹窗时立即重置所有状态
					this.resetImportForm();
				},

				// 格式化时间
				formatImportTime(timeValue) {
					if (!timeValue || timeValue === 'N/A') {
						return null;
					}

					try {
						// 如果是已经格式化的字符串，直接处理
						if (typeof timeValue === 'string') {
							// 1. 检查是否已经是 "YYYY-MM-DD HH:mm:ss" 格式
							if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(timeValue)) {
								return timeValue;
							}

							// 2. 检查是否是 "YYYY/MM/DD HH:mm:ss" 格式（你的Excel格式）
							if (/^\d{4}\/\d{2}\/\d{2} \d{2}:\d{2}:\d{2}$/.test(timeValue)) {
								// 将斜杠转换为连字符
								return timeValue.replace(/\//g, '-');
							}

							// 3. 如果是其他日期时间字符串，尝试解析
							const date = new Date(timeValue);
							if (!isNaN(date.getTime())) {
								// 格式化时间为 "YYYY-MM-DD HH:mm:ss"
								const year = date.getFullYear();
								const month = String(date.getMonth() + 1).padStart(2, '0');
								const day = String(date.getDate()).padStart(2, '0');
								const hours = String(date.getHours()).padStart(2, '0');
								const minutes = String(date.getMinutes()).padStart(2, '0');
								const seconds = String(date.getSeconds()).padStart(2, '0');

								return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
							}
						}

						// 如果是Date对象或时间戳
						if (timeValue instanceof Date) {
							const date = timeValue;
							const year = date.getFullYear();
							const month = String(date.getMonth() + 1).padStart(2, '0');
							const day = String(date.getDate()).padStart(2, '0');
							const hours = String(date.getHours()).padStart(2, '0');
							const minutes = String(date.getMinutes()).padStart(2, '0');
							const seconds = String(date.getSeconds()).padStart(2, '0');

							return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
						}

						// 如果是数字（可能是时间戳）
						if (typeof timeValue === 'number') {
							const date = new Date(timeValue);
							if (!isNaN(date.getTime())) {
								const year = date.getFullYear();
								const month = String(date.getMonth() + 1).padStart(2, '0');
								const day = String(date.getDate()).padStart(2, '0');
								const hours = String(date.getHours()).padStart(2, '0');
								const minutes = String(date.getMinutes()).padStart(2, '0');
								const seconds = String(date.getSeconds()).padStart(2, '0');

								return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
							}
						}

						return null;

					} catch (error) {
						console.error('格式化时间失败:', error, '原始值:', timeValue);
						return null;
					}
				},
				// 通用导入处理
				async handleImport() {
					if (!this.selectedFile) {
						this.$message.warning('请先选择文件');
						return;
					}

					// 新增：校验数据有效性，避免使用残留数据
					if (!this.excelPreviewData || this.excelPreviewData.length === 0) {
						this.$message.error('未检测到有效数据，请重新上传文件');
						this.resetImportForm(); // 重置状态
						return;
					}

					// 验证数据是否有效
					if (this.excelPreviewData && this.excelPreviewData.length === 0) {
						this.$message.error('没有有效数据可以导入');
						return;
					}

					// 检查验证结果
					if (this.excelData && this.excelData.validationResult) {
						const validation = this.excelData.validationResult;
						if (validation && !validation.isValid) {
							this.$message.error('数据验证未通过，请修复错误后再导入');
							return;
						}
					}

					this.importLoading = true;
					try {
						// 构建导入数据
						const importData = {
							file: this.selectedFile,
							type: this.importDialogType, // 'auto' 或 'manual'
							provider: this.selectedProvider, // 0=随机, 1=JCEX, 2=JS
							data: this.excelPreviewData,
							statistics: this.excelStatistics,
							totalCount: this.excelPreviewData.length
						};

						// 构建基础信息对象
						const importInfo = {
							user_id: this.userId,
							order_status: this.importDialogType === 'auto' ? 4 : 2, // 自动签收单-4，手动签收单-2
							track_type: this.selectedProvider, // 0=随机分配, 1=JCEX, 2=JS
							total: this.excelPreviewData.length,
							records: [] // 这里准备存储所有记录
						};

						// 在本地定义格式化函数，避免上下文问题
						const formatNestedAddress = (addressObj) => {
							if (!addressObj || typeof addressObj !== 'object') {
								return 'N/A';
							}

							const province = addressObj.province || '';
							const city = addressObj.city || '';
							const zip = addressObj.zipcode || '';
							const street = addressObj.street || '';

							const addressParts = [];
							if (province) addressParts.push(province);
							if (city) addressParts.push(city);
							if (zip) addressParts.push(zip);
							if (street) addressParts.push(street);

							return addressParts.length > 0 ? addressParts.join(',') : 'N/A';
						};

						const getProviderText = (value) => {
							const providerOptions = [{
									value: 0,
									label: '随机分配'
								},
								{
									value: 1,
									label: 'JCEX(佳成物流)'
								},
								{
									value: 2,
									label: 'JS(极速物流)'
								}
							];
							const option = providerOptions.find(opt => opt.value === value);
							return option ? option.label : '未知';
						};

						if (importInfo.total > 1000) {
							this.$message({
								message: '一次性上传数量不能大于1000条。',
								type: 'warning'
							});
							return
						}
						// 处理所有数据（不只是前3条）
						if (this.excelPreviewData && this.excelPreviewData.length > 0) {
							// 处理所有记录
							this.excelPreviewData.forEach((row, index) => {
								const record = {
									ecommerce_platform: row.platform || '未知平台',
									merchant_order_no: row.merchantOrderNo || `未提供_${index + 1}`,
									remark: row.remark || '',
									shipping_address: formatNestedAddress(row.sender) || '',
									receiving_address: formatNestedAddress(row.receiver) || '',
									track_start_time: this.formatImportTime(row.trackStartTime),
									track_end_time: this.formatImportTime(row.trackEndTime)
								};
								importInfo.records.push(record);
							});
						}
						// 修改确认弹窗的HTML内容
						this.$confirm(
							`<div class="import-confirm-container">
				          <div class="confirm-header">
				            <h3 class="confirm-title">确认导入</h3>
				          </div>
				          <div class="confirm-content">
				            <p class="confirm-text">确认导入 ${importInfo.total} 条${this.importDialogType === 'auto' ? '自动' : '手动'}签收单记录？</p>
				            <div class="import-details">
				              <div class="detail-item">
				                <span class="detail-label">物流商：</span>
				                <span class="detail-value">${getProviderText(this.selectedProvider)}</span>
				              </div>
				              <div class="detail-item">
				                <span class="detail-label">总记录数：</span>
				                <span class="detail-value">${importInfo.total} 条</span>
				              </div>
				              <div class="detail-item">
				                <span class="detail-label">订单类型：</span>
				                <span class="detail-value">${this.importDialogType === 'auto' ? '自动签收' : '手动签收'}</span>
				              </div>
				            </div>
				          </div>
						  
				        </div>`,
							'', {
								dangerouslyUseHTMLString: true,
								confirmButtonText: '确认导入',
								cancelButtonText: '取消',
								type: '',
								customClass: 'import-confirm-dialog',
								beforeClose: (action, instance, done) => {
									if (action === 'confirm') {
										// 禁用取消按钮和确认按钮
										instance.confirmButtonLoading = true;
										instance.cancelButtonLoading = true; // 也禁用取消按钮
										instance.confirmButtonText = '导入中...';
										instance.cancelButtonText = '';

										// 添加加载动画到确认按钮
										const confirmBtn = document.querySelector(
											'.import-confirm-dialog .el-button--primary');
										// if (confirmBtn) {
										// 	confirmBtn.classList.add('loading');
										// }
										// 执行导入逻辑
										this.performImport(importInfo).then((importResult) => {
											// 1. 先重置按钮状态
											// ✅ 关键修复：无论成功还是失败，都要重置按钮状态
											this.resetConfirmDialogButtons(instance, confirmBtn);

											// 2. 立即关闭确认弹窗
											done();

											if (importResult && importResult.success > 0) {
												// 关闭导入对话框
												this.importDialogVisible = false;

												// 短暂延迟确保UI更新完成
												setTimeout(() => {
													// 显示导入结果弹窗
													this.showImportResult(importResult);
												}, 300);

												// 重置表单
												this.resetImportForm();

												// 刷新订单列表和状态统计
												this.handleSearch();
												this.refreshStatusStats();

												// 显示成功消息
												this.$message.success(`成功导入 ${importResult.success} 个订单`);
											} else {
												this.$message.warning('导入完成但未找到成功记录');
											}
										}).catch((error) => {
											// 重置按钮状态
											this.resetConfirmDialogButtons(instance, confirmBtn);

											done();
											this.$message.error('导入失败：' + error.message);
											this.importLoading = false;
										});

										return false; // 阻止默认关闭
									} else {
										// 取消操作时也要确保状态重置
										this.importLoading = false;
										// ✅ 确保取消时也重置状态（如果之前有异常）
										if (instance) {
											instance.confirmButtonLoading = false;
											instance.cancelButtonLoading = false;
											instance.confirmButtonText = '确认导入';
											instance.cancelButtonText = '取消';
										}
										done(); // 取消操作
									}
								}
							}
						).then(() => {
							// 这里可以添加导入成功后的额外处理
						}).catch(() => {
							this.$message.info('已取消导入');
						});

					} catch (error) {
						console.error('导入失败:', error);
						this.$message.error('导入失败: ' + error.message);
					} finally {
						this.importLoading = false;
					}
				},
				// 重置确认弹窗按钮状态
				resetConfirmDialogButtons(instance, confirmBtn = null) {
					if (instance) {
						instance.confirmButtonLoading = false;
						instance.cancelButtonLoading = false;
						instance.confirmButtonText = '确认导入';
						instance.cancelButtonText = '取消';
					}

					if (confirmBtn) {
						confirmBtn.classList.remove('loading');
					}

					// 额外清理：确保所有相关按钮都恢复正常
					const allConfirmBtns = document.querySelectorAll('.import-confirm-dialog .el-button');
					allConfirmBtns.forEach(btn => {
						btn.disabled = false;
						btn.classList.remove('is-loading', 'loading');
					});
				},
				formatNestedAddress(addressObj) {
					if (!addressObj || typeof addressObj !== 'object') {
						return 'N/A';
					}

					const province = addressObj.province || '';
					const city = addressObj.city || '';
					const zip = addressObj.zipcode || '';
					const street = addressObj.street || '';

					const addressParts = [];
					if (province) addressParts.push(province);
					if (city) addressParts.push(city);
					if (zip) addressParts.push(zip);
					if (street) addressParts.push(street);

					return addressParts.length > 0 ? addressParts.join(',') : 'N/A';
				},
				// 加载SheetJS库
				loadSheetJS() {
					return new Promise((resolve, reject) => {
						if (typeof XLSX !== 'undefined') {
							resolve();
							return;
						}

						// 检查是否已加载
						if (window.XLSX) {
							resolve();
							return;
						}

						const script = document.createElement('script');
						script.src = 'https://cdn.jsdelivr.net/npm/xlsx@0.18.5/dist/xlsx.full.min.js';
						script.onload = () => {
							console.log('SheetJS库加载成功');
							resolve();
						};
						script.onerror = (error) => {
							console.error('SheetJS库加载失败:', error);
							reject(new Error('SheetJS库加载失败'));
						};
						document.head.appendChild(script);
					});
				},
				// 新增：显示导入结果详情
				// 显示导入结果详情（修复版）
				showImportResult(result) {
					// 存储导入结果，用于下载
					this.exportResult = result;

					// 构建弹窗内容
					let contentHtml = `
				    <div class="import-result-container" style="max-height: 500px; overflow-y: auto; padding: 10px;">
				      <div style="text-align: center; margin-bottom: 20px;">
				        <h3 style="color: #52c41a; margin: 0 0 10px 0; font-size: 20px;">
				          <i class="el-icon-success" style="font-size: 24px; vertical-align: middle; margin-right: 8px;"></i>
				          导入成功
				        </h3>
				        <p style="color: #666; margin: 0;">成功导入 ${result.success} 个订单</p>
				      </div>
				      
				      <!-- 扣费详情 -->
				      <div style="background: linear-gradient(135deg, #f6ffed 0%, #e6ffcc 100%); border-radius: 8px; padding: 15px; margin-bottom: 20px; border: 1px solid #b7eb8f;">
				        <h4 style="color: #389e0d; margin: 0 0 12px 0; font-size: 16px; display: flex; align-items: center;">
				          <i class="el-icon-money" style="margin-right: 8px;"></i>
				          积分扣费详情
				        </h4>
				        
				        <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px; margin-bottom: 10px;">
				          <div style="background: white; padding: 10px; border-radius: 6px; border: 1px solid #d9f7be;">
				            <div style="color: #8c8c8c; font-size: 12px;">扣费前余额</div>
				            <div style="color: #333; font-size: 18px; font-weight: bold;">
				              ${result.balance_before || result.deduction_detail.balance_before || '0.00'} 积分
				            </div>
				          </div>
				          
				          <div style="background: white; padding: 10px; border-radius: 6px; border: 1px solid #d9f7be;">
				            <div style="color: #8c8c8c; font-size: 12px;">本次扣费</div>
				            <div style="color: #ff4d4f; font-size: 18px; font-weight: bold;">
				              -${result.total_cost || result.deduction_detail.deduction_amount || '0.00'} 积分
				            </div>
				          </div>
				          
				          <div style="background: white; padding: 10px; border-radius: 6px; border: 1px solid #d9f7be;">
				            <div style="color: #8c8c8c; font-size: 12px;">扣费后余额</div>
				            <div style="color: #52c41a; font-size: 18px; font-weight: bold;">
				              ${result.balance_after || result.deduction_detail.balance_after || '0.00'} 积分
				            </div>
				          </div>
				        </div>
				        
				        <div style="display: flex; justify-content: space-between; background: white; padding: 10px; border-radius: 6px; border: 1px solid #d9f7be;">
				          <div>
				            <div style="color: #8c8c8c; font-size: 12px;">物流商</div>
				            <div style="color: #333; font-size: 14px; font-weight: bold;">
				              ${result.track_type_name || result.deduction_detail.track_type_name || '未分配'}
				            </div>
				          </div>
				          
				          <div>
				            <div style="color: #8c8c8c; font-size: 12px;">单价</div>
				            <div style="color: #333; font-size: 14px; font-weight: bold;">
				              ${result.unit_price || result.deduction_detail.unit_price || 2} 积分/单
				            </div>
				          </div>
				          
				          <div>
				            <div style="color: #8c8c8c; font-size: 12px;">订单数量</div>
				            <div style="color: #333; font-size: 14px; font-weight: bold;">
				              ${result.success} 单
				            </div>
				          </div>
				        </div>
				      </div>`

					contentHtml += `
				        <!-- 下载提示 -->
				        <div style="margin-top: 15px; padding: 10px; background: white; border-radius: 6px; border: 1px dashed #91d5ff;">
				          <div style="display: flex; align-items: center; color: #666; font-size: 13px;">
				            <i class="el-icon-download" style="color: #096dd9; margin-right: 8px; font-size: 16px;"></i>
				            <div>
				              <div style="font-weight: bold; color: #333; margin-bottom: 4px;">下载完整数据</div>
				              <div>下载包含物流单号的完整Excel文件，方便您跟踪和管理订单</div>
				            </div>
				          </div>
				        </div>
				      </div>
				  `;

					// 显示弹窗
					this.$msgbox({
						title: '导入结果详情',
						message: contentHtml,
						dangerouslyUseHTMLString: true,
						confirmButtonText: '下载Excel',
						customClass: 'import-result-detail-dialog',
						showCancelButton: false,
						closeOnClickModal: false,
						showClose: false,
						beforeClose: (action, instance, done) => {
							if (action === 'confirm') {
								// 点击下载Excel按钮
								instance.confirmButtonLoading = true;
								instance.confirmButtonText = '生成文件中...';

								// 生成并下载文件
								this.downloadResultWithTrackNumbers().finally(() => {
									done();
								});
							} else {
								done();
							}
						}
					}).then(action => {
						if (action === 'confirm') {
							this.$message.success('开始生成Excel文件');
						}
					}).catch(() => {
						this.$message.info('已关闭导入结果');
					});

				},
				// 生成包含物流单号的Excel并下载
				async downloadResultWithTrackNumbers() {
					if (!this.exportResult || !this.exportResult.assigned_track_numbers) {
						this.$message.warning('没有可下载的数据');
						return;
					}

					// 显示加载提示
					const loading = this.$loading({
						lock: true,
						text: '正在生成Excel文件...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});

					try {
						// 1. 将物流单号映射到商户订单号
						const trackNumberMap = {};
						this.exportResult.assigned_track_numbers.forEach(item => {
							trackNumberMap[item.order_number] = {
								track_num: item.track_num,
								order_id: item.order_id,
								order_number: item.order_number
							};
						});

						// 2. 获取用户上传的原始数据
						const originalData = this.allExcelData || this.excelPreviewData || [];

						// 3. 创建新的数据（将物流单号关联到原始数据）
						const enhancedData = originalData.map((row, index) => {
							// 尝试匹配订单号（根据你的Excel结构）
							const merchantOrderNo = row.merchantOrderNo || row.merchant_order_no || row[
								'商户订单号'] || '';
							const orderNumber = row.order_number || merchantOrderNo;

							// 查找对应的物流单号
							let trackInfo = null;

							// 方式1：通过订单号匹配
							if (orderNumber) {
								trackInfo = trackNumberMap[orderNumber];
							}

							// 方式2：如果没有找到，尝试按索引匹配（按顺序分配）
							if (!trackInfo && this.exportResult.assigned_track_numbers[index]) {
								trackInfo = this.exportResult.assigned_track_numbers[index];
							}

							// 方式3：通过商户订单号模糊匹配
							if (!trackInfo && merchantOrderNo) {
								const found = this.exportResult.assigned_track_numbers.find(item =>
									item.order_number.includes(merchantOrderNo) ||
									merchantOrderNo.includes(item.order_number)
								);
								if (found) trackInfo = found;
							}

							// 获取物流商名称
							const trackTypeName = this.exportResult.track_type_name ||
								this.exportResult.deduction_detail.track_type_name ||
								'JCEX';

							// 获取物流商类型对应的中文名称
							const providerMap = {
								'1': 'JCEX(佳成物流)',
								'2': 'JS(极速物流)',
								'JCEX': 'JCEX(佳成物流)',
								'JS': 'JS(极速物流)'
							};

							const providerName = providerMap[trackTypeName] || trackTypeName;

							return {
								// 原始数据
								...row,
								// 新增字段
								'系统订单号': trackInfo.order_number || '',
								'订单ID': trackInfo.order_id || '',
								'物流单号': trackInfo.track_num || '',
								'物流商': providerName,
								'分配状态': trackInfo.track_num ? '已分配' : '未分配',
								'分配时间': new Date().toLocaleString('zh-CN'),
								'扣费单价(积分)': this.exportResult.unit_price || this.exportResult.deduction_detail
									.unit_price || 2,
								'备注': row.remark || row.备注 || ''
							};
						});

						// 4. 创建Excel数据数组
						const excelData = [];

						// 添加标题行（第一行）
						excelData.push([
							'白羊轨迹定制测试系统 - 订单导入结果',
							'', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''
						]);

						// 添加第二行：导入基本信息
						excelData.push([
							`导入时间: ${new Date().toLocaleString('zh-CN')}`,
							`总订单数: ${this.exportResult.total || enhancedData.length}`,
							`成功导入: ${this.exportResult.success || 0}`,
							`失败: ${this.exportResult.failed || 0}`,
							'', '', '', '', '', '', '', '', '', '', '', '', ''
						]);

						// 添加第三行：物流商信息
						excelData.push([
							`物流商: ${this.exportResult.track_type_name || this.exportResult.deduction_detail.track_type_name || '未分配'}`,
							`单价: ${this.exportResult.unit_price || this.exportResult.deduction_detail.unit_price || 2} 积分/单`,
							`总扣费: ${this.exportResult.total_cost || this.exportResult.deduction_detail.deduction_amount || 0} 积分`,
							'', '', '', '', '', '', '', '', '', '', '', '', '', ''
						]);

						// 添加第四行：余额信息
						excelData.push([
							`扣费前余额: ${this.exportResult.balance_before || this.exportResult.deduction_detail.balance_before || 0} 积分`,
							`扣费后余额: ${this.exportResult.balance_after || this.exportResult.deduction_detail.balance_after || 0} 积分`,
							'', '', '', '', '', '', '', '', '', '', '', '', '', '', ''
						]);

						// 空行
						excelData.push([]);

						// 添加表头
						const headers = [
							'序号',
							'商户订单号',
							'电商平台',
							'系统订单号',
							'订单ID',
							'物流单号',
							'物流商',
							'分配状态',
							'分配时间',
							'发件人省份',
							'发件人城市',
							'发件人地址',
							'发件人邮编',
							'收件人省份',
							'收件人城市',
							'收件人地址',
							'收件人邮编',
							'轨迹开始时间',
							'轨迹结束时间',
							'扣费单价(积分)',
							'备注'
						];
						excelData.push(headers);

						// 添加数据行
						enhancedData.forEach((row, index) => {
							// 处理地址数据
							const senderAddress = row.sender || row.formattedSenderAddress || {};
							const receiverAddress = row.receiver || row.formattedReceiverAddress || {};

							const dataRow = [
								index + 1,
								row.merchantOrderNo || row.merchant_order_no || row['商户订单号'] || '',
								row.platform || row.ecommerce_platform || row['电商平台'] || '',
								row['系统订单号'] || '',
								row['订单ID'] || '',
								row['物流单号'] || '',
								row['物流商'] || '',
								row['分配状态'] || '',
								row['分配时间'] || '',
								senderAddress.province || senderAddress.state || row['发件人省份'] || '',
								senderAddress.city || row['发件人城市'] || '',
								senderAddress.address || senderAddress.street || row['发件人地址'] || '',
								senderAddress.zipcode || row['发件人邮编'] || '',
								receiverAddress.province || receiverAddress.state || row['收件人省份'] || '',
								receiverAddress.city || row['收件人城市'] || '',
								receiverAddress.address || receiverAddress.street || row['收件人地址'] || '',
								receiverAddress.zipcode || row['收件人邮编'] || '',
								row.trackStartTime || row['轨迹开始时间'] || '',
								row.trackEndTime || row['轨迹结束时间'] || '',
								row['扣费单价(积分)'] || '',
								row.remark || row.备注 || ''
							];

							excelData.push(dataRow);
						});

						// 5. 使用SheetJS库生成Excel
						if (typeof XLSX === 'undefined') {
							// 动态加载SheetJS库
							await this.loadSheetJS();
						}

						// 创建工作簿
						const wb = XLSX.utils.book_new();

						// 创建工作表
						const ws = XLSX.utils.aoa_to_sheet(excelData);

						// 设置列宽
						const colWidths = [{
								wch: 6
							}, // 序号
							{
								wch: 20
							}, // 商户订单号
							{
								wch: 12
							}, // 电商平台
							{
								wch: 20
							}, // 系统订单号
							{
								wch: 10
							}, // 订单ID
							{
								wch: 20
							}, // 物流单号
							{
								wch: 12
							}, // 物流商
							{
								wch: 10
							}, // 分配状态
							{
								wch: 18
							}, // 分配时间
							{
								wch: 12
							}, // 发件人省份
							{
								wch: 10
							}, // 发件人城市
							{
								wch: 20
							}, // 发件人地址
							{
								wch: 10
							}, // 发件人邮编
							{
								wch: 12
							}, // 收件人省份
							{
								wch: 10
							}, // 收件人城市
							{
								wch: 20
							}, // 收件人地址
							{
								wch: 10
							}, // 收件人邮编
							{
								wch: 18
							}, // 轨迹开始时间
							{
								wch: 18
							}, // 轨迹结束时间
							{
								wch: 12
							}, // 扣费单价
							{
								wch: 30
							} // 备注
						];
						ws['!cols'] = colWidths;

						// 合并标题行
						ws['!merges'] = [{
								s: {
									r: 0,
									c: 0
								},
								e: {
									r: 0,
									c: 20
								}
							}, // 第一行合并
							{
								s: {
									r: 1,
									c: 0
								},
								e: {
									r: 1,
									c: 3
								}
							}, // 第二行合并
							{
								s: {
									r: 2,
									c: 0
								},
								e: {
									r: 2,
									c: 2
								}
							}, // 第三行合并
							{
								s: {
									r: 3,
									c: 0
								},
								e: {
									r: 3,
									c: 1
								}
							} // 第四行合并
						];

						// 将工作表添加到工作簿
						XLSX.utils.book_append_sheet(wb, ws, '订单导入结果');

						// 6. 添加汇总信息工作表
						const summaryData = [
							['订单导入汇总信息'],
							[],
							['导入时间', new Date().toLocaleString('zh-CN')],
							['总订单数', this.exportResult.total || 0],
							['成功导入', this.exportResult.success || 0],
							['失败', this.exportResult.failed || 0],
							[],
							['扣费信息'],
							['物流商', this.exportResult.track_type_name || this.exportResult.deduction_detail
								.track_type_name || '未分配'
							],
							['单价(积分/单)', this.exportResult.unit_price || this.exportResult.deduction_detail
								.unit_price || 2
							],
							['总扣费(积分)', this.exportResult.total_cost || this.exportResult.deduction_detail
								.deduction_amount || 0
							],
							['扣费前余额(积分)', this.exportResult.balance_before || this.exportResult.deduction_detail
								.balance_before || 0
							],
							['扣费后余额(积分)', this.exportResult.balance_after || this.exportResult.deduction_detail
								.balance_after || 0
							],
							[],
							['物流单号分配清单'],
							['序号', '订单号', '物流单号', '订单ID']
						];

						// 添加物流单号列表
						this.exportResult.assigned_track_numbers.forEach((item, index) => {
							summaryData.push([
								index + 1,
								item.order_number || '',
								item.track_num || '',
								item.order_id || ''
							]);
						});

						const ws2 = XLSX.utils.aoa_to_sheet(summaryData);
						ws2['!cols'] = [{
								wch: 8
							},
							{
								wch: 25
							},
							{
								wch: 20
							},
							{
								wch: 10
							}
						];

						XLSX.utils.book_append_sheet(wb, ws2, '导入汇总');

						// 生成Excel文件
						const wbout = XLSX.write(wb, {
							bookType: 'xlsx',
							type: 'array'
						});

						// 创建Blob并下载
						const blob = new Blob([wbout], {
							type: 'application/octet-stream'
						});
						const url = URL.createObjectURL(blob);
						const link = document.createElement('a');

						// 生成文件名
						const dateStr = new Date().toISOString().slice(0, 10).replace(/-/g, '');
						const timeStr = new Date().toTimeString().slice(0, 8).replace(/:/g, '');
						const fileName = `订单导入结果_${dateStr}_${timeStr}.xlsx`;

						link.href = url;
						link.download = fileName;
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						URL.revokeObjectURL(url);

						loading.close();

						// 记录下载日志
						console.log('Excel文件生成成功:', {
							文件名: fileName,
							总行数: enhancedData.length,
							物流单号数: this.exportResult.assigned_track_numbers.length,
							扣费总额: this.exportResult.total_cost
						});

					} catch (error) {
						console.error('生成Excel失败:', error);
						loading.close();
						this.$message.error('Excel文件生成失败: ' + error.message);

						// 降级方案：生成CSV文件
						this.downloadResultAsCSV();
					}
				},
				// 重置导入表单
				resetImportForm() {
					this.selectedFile = null;
					this.selectedFileName = '';
					this.selectedProvider = 1; // 重置为默认值
					this.showExcelPreview = false; // 重置预览状态
					this.excelPreviewData = []; // 清空预览数据
					this.excelStatistics = null; // 清空统计数据
					this.importLoading = false; // 确保重置加载状态

					if (this.$refs.fileInput) {
						this.$refs.fileInput.value = '';
					}
				},
				// 获取状态文本
				getStatusText(status) {
					const statusMap = {
						'0': '全部订单',
						'1': '待确认单',
						'2': '手动签收单',
						'3': '待签收',
						'4': '自动签收单',
						'5': '已取消'
					};
					return statusMap[status] || '未知状态';
				},
				// 处理复选框选择
				handleSelectionChange(selection) {
					this.selectedOrderIds = selection.map(item => item.id);
					this.selectedOrders = selection;

					// 如果没有选中任何订单，禁用所有批量按钮
					if (selection.length === 0) {
						this.batchButtons = {
							cancel: false,
							confirm: false,
							sign: false
						};
						return;
					}

					// 如果当前是"全部订单"标签，需要检查每个订单的状态
					if (this.activeTab === '0') {
						// 使用新的辅助方法
						const statusCount = this.countSelectionByStatus(selection);
						this.updateButtonsByStatusCount(statusCount);
					}
				},
				// 获取用户ID
				getUserId() {
					// 方式1：从localStorage直接获取
					const userId = localStorage.getItem('user_id')

					if (userId) {
						const parsedId = parseInt(userId);
						if (!isNaN(parsedId) && parsedId > 0) {
							return parsedId;
						}
					}

					// 方式2：从user_info对象中获取
					try {
						const userInfo = localStorage.getItem('user_info')

						if (userInfo) {
							const user = JSON.parse(userInfo)
							const userId = user.id || 0

							if (userId && userId > 0) {
								// 同时保存到独立的字段，方便下次获取
								localStorage.setItem('user_id', userId);
								return userId;
							}
						}
					} catch (error) {
						console.error('读取用户ID失败:', error)
					}

					console.warn('未获取到有效用户ID，返回0');
					return 0 // 默认返回0表示未登录
				},
				// 执行导入的核心方法
				async performImport(importInfo) {
					return new Promise(async (resolve, reject) => {
						try {
							// 显示进度提示
							this.$message({
								message: '正在导入数据，请稍候...',
								type: 'warning',
								duration: 0,
								showClose: false,
								customClass: 'import-progress-messages'
							});

							// 在本地定义格式化函数
							const formatNestedAddress = (addressObj) => {
								if (!addressObj || typeof addressObj !== 'object') {
									return 'N/A';
								}

								const province = addressObj.province || '';
								const city = addressObj.city || '';
								const zip = addressObj.zipcode || '';
								const street = addressObj.street || '';

								const addressParts = [];
								if (province) addressParts.push(province);
								if (city) addressParts.push(city);
								if (zip) addressParts.push(zip);
								if (street) addressParts.push(street);

								return addressParts.length > 0 ? addressParts.join(',') : 'N/A';
							};

							// 构建请求数据
							const requestData = {
								user_id: importInfo.user_id,
								order_status: importInfo.order_status,
								track_type: importInfo.track_type,
								lineType:this.selectedLine,
								records: importInfo.records.map(record => ({
									ecommerce_platform: record.ecommerce_platform,
									merchant_order_no: record.merchant_order_no,
									shipping_address: record.shipping_address,
									receiving_address: record.receiving_address,
									track_start_time: record.track_start_time !== 'N/A' ?
										record.track_start_time : null,
									track_end_time: record.track_end_time !== 'N/A' ? record
										.track_end_time : null,
									remark: record.remark !== 'N/A' ? record.remark : '',
								}))
							};

							const response = await fetch('/import_orders.php', {
								method: 'POST',
								headers: {
									'Content-Type': 'application/json',
								},
								body: JSON.stringify(requestData)
							});

							// 关闭进度提示
							this.$message.closeAll();

							if (!response.ok) {
								throw new Error(`HTTP错误! 状态码: ${response.status}`);
							}

							const result = await response.json();

							if (result.code === 200) {
								// 重置导入加载状态
								this.importLoading = false;
								resolve({
									success: result.data.success || 0,
									failed: result.data.failed || 0,
									total: result.data.total || 0,
									track_type: result.data.track_type,
									track_type_name: result.data.track_type_name,
									assigned_track_numbers: result.data.assigned_track_numbers || [],
									failures: result.data.failures || [],

									// 新增：扣费相关字段
									unit_price: result.data.unit_price || 2,
									total_cost: result.data.total_cost || 0,
									balance_before: result.data.balance_before || 0,
									balance_after: result.data.balance_after || 0,
									deduction_detail: result.data.deduction_detail || null,

									// 可选：保存原始数据用于调试
									raw_data: result.data,
								});
								//进入生成轨迹方法
								// this.get_to_tracks(result.data.assigned_track_numbers);
							} else {
								// 重置导入加载状态
								this.importLoading = false;
								reject(new Error(result.msg || '导入失败'));
							}
						} catch (error) {
							// 关闭进度提示
							this.$message.closeAll();
							console.error('调用导入接口失败:', error);
							// 重置导入加载状态
							this.importLoading = false;
							reject(error);
						}
					});
				},
				//点击单号进入超链接。
				getLinkUrl(orderNo) {
					if (!orderNo) return 'javascript:void(0);'
					// 根据实际需求拼接URL
					return `https://t.17track.net/zh-cn#nums=${orderNo}`
					// 或者
					// return `/order/detail/${orderNo}`
				},
				// 生成轨迹方法 - 适配新的详细响应格式
				async get_to_tracks(assigned_track_numbers) {
					if (!assigned_track_numbers || assigned_track_numbers.length === 0) {
						console.warn('没有需要生成轨迹的订单');
						return;
					}

					const TOTAL_COUNT = assigned_track_numbers.length;

					// 创建全屏遮罩
					const createLoadingOverlay = () => {
						const overlay = document.createElement('div');
						overlay.style.cssText = `
				            position: fixed;
				            top: 0;
				            left: 0;
				            width: 100%;
				            height: 100%;
				            background: rgba(0, 0, 0, 0.7);
				            display: flex;
				            flex-direction: column;
				            justify-content: center;
				            align-items: center;
				            z-index: 9999;
				            color: white;
				            font-size: 16px;
				        `;

						// 添加加载图标
						const spinner = document.createElement('div');
						spinner.className = 'el-icon-loading';
						spinner.style.cssText = `
				            font-size: 48px;
				            margin-bottom: 20px;
				            animation: rotating 2s linear infinite;
				        `;

						// 添加标题文字
						const title = document.createElement('div');
						title.textContent = `正在生成 ${TOTAL_COUNT} 个物流单号轨迹...`;
						title.style.cssText = `
				            font-size: 18px;
				            font-weight: 600;
				            margin-bottom: 10px;
				        `;

						// 添加进度信息
						const progress = document.createElement('div');
						progress.id = 'batch-track-progress';
						progress.textContent = '准备中...';
						progress.style.cssText = `
				            margin-top: 10px;
				            font-size: 14px;
				            color: #ccc;
				        `;

						// 添加进度条容器
						const progressBarContainer = document.createElement('div');
						progressBarContainer.style.cssText = `
				            width: 300px;
				            height: 8px;
				            background: rgba(255, 255, 255, 0.2);
				            border-radius: 4px;
				            margin-top: 15px;
				            overflow: hidden;
				        `;

						// 添加进度条
						const progressBar = document.createElement('div');
						progressBar.id = 'batch-track-progress-bar';
						progressBar.style.cssText = `
				            width: 0%;
				            height: 100%;
				            background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
				            border-radius: 4px;
				            transition: width 0.3s ease;
				        `;

						progressBarContainer.appendChild(progressBar);

						overlay.appendChild(spinner);
						overlay.appendChild(title);
						overlay.appendChild(progress);
						overlay.appendChild(progressBarContainer);
						document.body.appendChild(overlay);

						return {
							close: () => {
								if (overlay && overlay.parentNode) {
									overlay.parentNode.removeChild(overlay);
								}
							},
							updateText: (newText) => {
								title.textContent = newText;
							},
							updateProgress: (progressText) => {
								progress.textContent = progressText;
							},
							updateProgressBar: (percent) => {
								const bar = document.getElementById('batch-track-progress-bar');
								if (bar) {
									bar.style.width = `${percent}%`;
								}
							}
						};
					};

					let loadingOverlay = null;

					try {
						// 创建遮罩
						loadingOverlay = createLoadingOverlay();

						// 更新进度条到0%
						loadingOverlay.updateProgressBar(0);
						loadingOverlay.updateProgress('正在准备数据...');

						// 1. 准备批量数据
						const batchData = {
							tracks: assigned_track_numbers.map(item => ({
								track_num: item.track_num || '',
								shipping_address: item.shipping_address || '',
								receiving_address: item.receiving_address || '',
								track_start_time: item.track_start_time || '',
								track_end_time: item.track_end_time || '',
								order_id: item.order_id || 0,
								order_number: item.order_number || ''
							}))
						};

						loadingOverlay.updateProgressBar(10);
						loadingOverlay.updateProgress('正在发送请求到服务器...');

						// 2. 发送请求
						const response = await fetch('/batch_to_tracks.php', {
							method: 'POST',
							headers: {
								'Content-Type': 'application/json',
							},
							body: JSON.stringify(batchData)
						});

						loadingOverlay.updateProgressBar(30);
						loadingOverlay.updateProgress('正在接收服务器响应...');

						// 3. 处理响应
						if (!response.ok) {
							const errorText = await response.text();
							throw new Error(`服务器响应错误: ${response.status} - ${errorText}`);
						}

						const result = await response.json();
						loadingOverlay.updateProgressBar(70);
						loadingOverlay.updateProgress('正在处理响应数据...');

						// 4. 处理结果 - 根据新的响应结构
						if (result.success) {
							const totalTracks = result.total_tracks || 0;
							const successCount = result.success_count || 0; // 技术和业务都成功
							const technicalSuccessCount = result.technical_success_count || 0; // 仅技术成功
							const failedCount = result.failed_count || 0; // 技术失败
							const businessFailedCount = result.business_failed_count || 0; // 业务失败

							loadingOverlay.updateProgressBar(100);

							// 延迟500ms后关闭遮罩，让用户看到100%进度
							setTimeout(() => {
								if (loadingOverlay) {
									loadingOverlay.close();
								}

								// 显示结果弹窗 - 传入更多参数
								this.showBatchTrackResult(result, {
									totalTracks,
									successCount,
									technicalSuccessCount,
									failedCount,
									businessFailedCount,
									businessSuccess: result.business_success || false
								});

								// 播放成功音效（可选）
								if (successCount > 0 || technicalSuccessCount > 0) {
									this.playSuccessSound();
								}

							}, 500);

						} else {
							// 如果整体技术失败
							if (loadingOverlay) {
								loadingOverlay.close();
							}
							this.$message.error({
								message: `轨迹生成失败: ${result.message || '未知错误'}`,
								showClose: true,
								duration: 0
							})
						}

					} catch (error) {
						console.error('批量轨迹生成失败:', error);

						// 确保关闭遮罩
						if (loadingOverlay) {
							loadingOverlay.close();
						}
						this.$message.error({
							message: `轨迹生成失败: ${error.message || '未知错误'}`,
							showClose: true,
							duration: 0
						})
					}
				},

				// 新增：显示批量轨迹生成结果（适配新格式）
				showBatchTrackResult(result, stats) {
					const {
						totalTracks,
						successCount,
						technicalSuccessCount,
						failedCount,
						businessFailedCount,
						businessSuccess
					} = stats;

					const callbackResponses = result.callback_responses || [];

					// 统计各状态数量
					let completeSuccess = 0; // 完全成功（code 200）
					let businessFailed = 0; // 业务失败（code 非200）

					if (callbackResponses && callbackResponses.length > 0) {
						callbackResponses.forEach(item => {
							const response = item.callback_response || {};
							if (response.code === 200) {
								completeSuccess++;
							} else {
								businessFailed++;
							}
						});
					}

				},
				// 充值 弹窗
				handleRecharge() {
					// 定义充值套餐（没有加赠）
					const rechargePlans = [{
							amount: 100,
							points: 100,
							popular: false
						},
						{
							amount: 300,
							points: 300,
							popular: false
						}, // 300元作为推荐套餐
						{
							amount: 500,
							points: 500,
							popular: false
						},
						{
							amount: 1000,
							points: 1000,
							popular: true
						},
						{
							amount: 3000,
							points: 3000,
							popular: false
						},
						{
							amount: 5000,
							points: 5000,
							popular: false
						},
						{
							amount: 8000,
							points: 8000,
							popular: false
						}
					];

					// 构建弹窗HTML内容
					const html = `
				    <div class="recharge-popup-container">
				        <div class="recharge-header" style="text-align: center; padding: 20px 0;">
				            <div class="recharge-title" style="display: flex; align-items: center; justify-content: center; margin-bottom: 8px;">
				                <i class="el-icon-money" style="color: #FFD700; font-size: 28px; margin-right: 12px;"></i>
				                <span style="font-size: 22px; font-weight: 700; color: #333; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent;">
				                    积分在线兑换
				                </span>
				            </div>
				            <div class="recharge-subtitle" style="color: #666; font-size: 14px;">
				                1:1兑换比例，充值金额=获得积分
				            </div>
				        </div>
				
				        <div class="recharge-plans-container" style="padding: 0 20px;">
				            <div class="plans-grid" style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 15px; margin-bottom: 20px;">
				                ${rechargePlans.map((plan, index) => `
				                <div class="plan-card ${plan.popular ? 'popular' : ''}" 
				                     data-amount="${plan.amount}" 
				                     style="position: relative; cursor: pointer; background: white; border: 2px solid ${plan.popular ? '#FFD700' : '#e4e7ed'}; border-radius: 12px; padding: 20px 15px; text-align: center; transition: all 0.3s ease; ${plan.popular ? 'background: linear-gradient(135deg, #fff9e6 0%, #fff4cc 100%);' : ''}"
				                     onclick="window.selectRechargePlan(${plan.amount})">
				                    ${plan.popular ? '<div style="position: absolute; top: -10px; left: 50%; transform: translateX(-50%); background: linear-gradient(135deg, #FFB800 0%, #FFD700 100%); color: white; font-size: 12px; font-weight: 600; padding: 4px 15px; border-radius: 10px; box-shadow: 0 3px 8px rgba(255, 184, 0, 0.3);">推荐</div>' : ''}
				                    
				                    <div class="plan-amount" style="margin-bottom: 15px;">
				                        <div style="font-size: 14px; color: #999; margin-bottom: 5px;">充值</div>
				                        <div style="display: flex; align-items: baseline; justify-content: center;">
				                            <span style="font-size: 18px; color: #ff6b6b; font-weight: 600; margin-right: 2px;">¥</span>
				                            <span style="font-size: 32px; font-weight: 800; color: #333;">${plan.amount.toLocaleString()}</span>
				                        </div>
				                    </div>
				                    
				                    <div class="plan-divider" style="height: 1px; background: linear-gradient(90deg, transparent, #e4e7ed, transparent); margin: 15px 0;"></div>
				                    
				                    <div class="plan-points" style="margin-bottom: 15px;">
				                        <div style="font-size: 14px; color: #999; margin-bottom: 5px;">获得</div>
				                        <div style="display: flex; align-items: center; justify-content: center; gap: 8px;">
				                            <i class="el-icon-coin" style="color: #FFD700; font-size: 20px;"></i>
				                            <span style="font-size: 24px; font-weight: 800; color: #333;">${plan.points.toLocaleString()}</span>
				                            <span style="font-size: 14px; color: #666; font-weight: 500;">积分</span>
				                        </div>
				                    </div>
				                    
				                    <div class="plan-ratio" style="font-size: 12px; color: #00C48C; background: rgba(0, 196, 140, 0.1); padding: 4px 8px; border-radius: 12px; margin-bottom: 15px; display: inline-block;">
				                        1:1兑换
				                    </div>
				                    
				                    <div class="plan-action" style="background: ${plan.popular ? 'linear-gradient(135deg, #FFB800 0%, #FFD700 100%)' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'}; color: white; font-size: 14px; font-weight: 600; padding: 10px 0; border-radius: 8px; transition: all 0.3s ease;">
				                        ${plan.popular ? '立即兑换' : '立即兑换'}
				                    </div>
				                </div>
				                `).join('')}
				            </div>
				            
				            <!-- 超大额充值选项 -->
				            <div class="large-amount-option" style="background: linear-gradient(135deg, #f8f9ff 0%, #f0f2ff 100%); border-radius: 12px; padding: 20px; margin-top: 20px; border: 2px dashed #667eea;">
				                <div style="text-align: center; margin-bottom: 15px;">
				                    <i class="el-icon-star-on" style="color: #FFD700; font-size: 24px; margin-right: 8px;"></i>
				                    <span style="font-size: 16px; font-weight: 600; color: #333;">大额兑换</span>
				                </div>
				                <div style="display: flex; gap: 10px; margin-bottom: 10px;">
				                    <button onclick="window.selectRechargePlan(10000)" 
				                            style="flex: 1; padding: 12px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); 
				                                   color: white; border: none; border-radius: 8px; cursor: pointer; font-weight: 600; font-size: 14px;">
				                        ¥10,000 = 10,000积分
				                    </button>
				                    <button onclick="window.selectRechargePlan(20000)" 
				                            style="flex: 1; padding: 12px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); 
				                                   color: white; border: none; border-radius: 8px; cursor: pointer; font-weight: 600; font-size: 14px;">
				                        ¥20,000 = 20,000积分
				                    </button>
				                </div>
				            </div>
				        </div>
				
				    </div>`;

					// 注入全局函数到window对象
					window.selectRechargePlan = (amount) => {
						this.selectRechargePlan(amount);
					};

					window.submitCustomAmount = () => {
						const input = document.getElementById('customAmountInput');
						const value = parseInt(input.value);
						const error = document.getElementById('customAmountError');
						const errorText = document.getElementById('errorText');

						if (!value || isNaN(value)) {
							errorText.textContent = '请输入有效的金额';
							error.style.display = 'block';
							input.focus();
							return;
						}

						if (value < 100) {
							errorText.textContent = '最低充值金额为100元';
							error.style.display = 'block';
							input.focus();
							return;
						}

						if (value > 50000) {
							errorText.textContent = '单次最高充值金额为50000元';
							error.style.display = 'block';
							input.focus();
							return;
						}

						if (value % 1 !== 0) {
							errorText.textContent = '请输入整数金额';
							error.style.display = 'block';
							input.focus();
							return;
						}

						error.style.display = 'none';
						this.selectRechargePlan(value);
					};

					window.validateCustomAmount = (input) => {
						const error = document.getElementById('customAmountError');
						const value = parseInt(input.value);
						const submitBtn = document.getElementById('customSubmitBtn');

						if (value && value >= 100 && value <= 50000 && value % 1 === 0) {
							error.style.display = 'none';
							submitBtn.style.opacity = '1';
							submitBtn.disabled = false;
							// 更新按钮显示
							submitBtn.innerHTML = `兑换 ${value.toLocaleString()} 积分`;
						} else {
							submitBtn.innerHTML = '立即兑换';
							submitBtn.style.opacity = '0.7';
						}
					};

					window.refreshBalance = () => {
						this.refreshBalance();
						this.$message.success('余额已刷新');
					};

					// 显示弹窗
					this.$msgbox({
						title: '',
						message: html,
						dangerouslyUseHTMLString: true,
						showCancelButton: true,
						cancelButtonText: '取消',
						confirmButtonText: '查看兑换记录',
						customClass: 'simple-recharge-dialog',
						width: '720px',
						center: true,
						closeOnClickModal: false,
						// 控制关闭行为
						closeOnClickModal: true, // 点击空白处关闭（默认true）
						closeOnPressEscape: true, // 按ESC键关闭（默认true）
						beforeClose: (action, instance, done) => {
							// 清理全局函数
							delete window.selectRechargePlan;
							delete window.submitCustomAmount;
							delete window.validateCustomAmount;
							delete window.refreshBalance;
							done();
						}
					}).then(action => {
						if (action === 'confirm') {
							this.showRechargeDialog();
						}
					}).catch(() => {
						// 清理全局函数
						delete window.selectRechargePlan;
						delete window.submitCustomAmount;
						delete window.validateCustomAmount;
						delete window.refreshBalance;
					});
				},

				// 选择充值金额的方法
				selectRechargePlan(amount) {
					this.$msgbox.close(); // 关闭选择弹窗

					this.processPayment(amount);
				},

				// 处理支付
				processPayment(amount) {
					// 显示加载中
					this.paymentLoading = true;
					const loadingInstance = this.$loading({
						lock: true,
						text: `正在创建支付订单，金额：${amount}`,
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});

					// 调用后端创建订单接口
					fetch('create.php', {
							method: 'POST',
							headers: {
								'Content-Type': 'application/x-www-form-urlencoded',
							},
							body: new URLSearchParams({
								price: amount,
								param: JSON.stringify({
									userId: this.userId,
									userPhone: this.userPhone
								})
							})
						})
						.then(response => response.json())
						.then(result => {
							this.paymentLoading = false;

							if (result.code === 1) { // 成功码为1
								// 根据返回的支付链接类型进行处理
								if (result.data && result.data.payUrl) {
									const payUrl = result.data.payUrl;
									const merchantOrderId = result.data.merchant_order_id || result.data.order_id ||
										'未知订单号';
									const createdTime = result.data.created_time || new Date().toLocaleString();
									const timeoutMinutes = result.data.timeOut || 3;
									// 判断是微信支付链接还是二维码链接
									if (payUrl.startsWith('wxp://') || payUrl.startsWith('weixin://')) {
										// 微信支付链接，直接跳转
										this.handleWechatPay(payUrl, result.data.reallyPrice, result.data.payId,
											createdTime,
											timeoutMinutes, loadingInstance);
									}

								}

								// 保存订单信息（用于后续查询）
								this.currentOrder = result.data;
								this.startPaymentCheck(result)
							} else {
								// 订单创建失败
								this.$message.error(result.msg || '订单创建失败');
							}
						})
				},
				// 添加显示支付信息的方法
				showPaymentInfo(amount, merchantOrderId, createdTime, timeoutMinutes) {

					const alertInstance = this.$alert(`
				        <div style="text-align: center; padding: 20px;">
				            <h3 style="color: #409EFF; margin-bottom: 15px;">支付提示</h3>
				            
				            <!-- 重要提示 -->
				            <div style="background: #e6f7ff; border: 1px solid #91d5ff; border-radius: 6px; padding: 10px; margin-bottom: 15px;">
				                <div style="color: #1890ff; font-weight: 600; margin-bottom: 5px;">
				                    <i class="el-icon-info"></i> 重要提示
				                </div>
				                <div style="font-size: 14px; color: #666;">
				                    请严格按照订单金额 <span style="color: #f5222d; font-weight: 600;font-size: 24px;">¥${amount}</span> 进行支付
				                </div>
				            </div>
				            
				            <!-- 倒计时显示 -->
				            <div id="payment-timer" style="margin: 15px 0; font-size: 16px; color: #f5222d; font-weight: 600;">
				                支付倒计时: <span id="time-left">${timeoutMinutes}:00</span>
				            </div>
				            
				            <!-- 订单信息 -->
				            <div style="background: #f5f7fa; border-radius: 6px; padding: 12px; margin: 15px 0; text-align: left;">
				                <div style="margin-bottom: 6px;">
				                    <span style="color: #666; font-size: 12px;">商户订单号:</span>
				                    <span style="color: #333; font-weight: 500; margin-left: 8px;">${merchantOrderId}</span>
				                </div>
				                <div>
				                    <span style="color: #666; font-size: 12px;">创建时间:</span>
				                    <span style="color: #333; font-weight: 500; margin-left: 8px;">${createdTime}</span>
				                </div>
				            </div>
				            
				            <p style="color: #909399; font-size: 14px; margin-top: 15px;">
				                支付完成后，请返回本页面查看支付结果
				            </p>
				        </div>
				    `, '支付提示', {
						dangerouslyUseHTMLString: true,
						showConfirmButton: false,
						showCloseButton: true,
						customClass: 'payment-info-dialog',
						closeOnClickModal: false,
						beforeClose: (action, instance, done) => {
							// 在弹窗关闭时清理计时器
							if (this.paymentCountdownTimer) {
								clearInterval(this.paymentCountdownTimer);
							}
							done();
						}
					});

					// 启动倒计时
					this.startPaymentCountdown(timeoutMinutes, alertInstance);
				},
				// 修改 handleWechatPay 方法
				async handleWechatPay(payUrl, amount, merchantOrderId, createdTime, timeoutMinutes, loadingInstance) {
					if (/MicroMessenger/i.test(navigator.userAgent)) {
						// 在微信内，直接跳转
						window.location.href = payUrl;
						// 在微信内也显示支付提示
						this.showPaymentInfo(amount, merchantOrderId, createdTime, timeoutMinutes);
						return;
					}

					try {
						// 1. 确保QRCode库已加载
						await this.ensureQRCodeLibrary();

						// 2. 显示弹窗
						const alertInstance = this.$alert(`
				            <div style="text-align: center; padding: 20px;">
				                <h3 style="color: #e6a23c; margin-bottom: 15px;">微信支付</h3>
				                
				                <!-- 重要提示 -->
				                <div style="background: #fffbe6; border: 1px solid #ffe58f; border-radius: 6px; padding: 10px; margin-bottom: 15px;">
				                    <div style="color: #fa8c16; font-weight: 600; margin-bottom: 5px;">
				                        <i class="el-icon-warning"></i> 重要提示
				                    </div>
				                    <div style="font-size: 14px; color: #666;">
				                        请严格按照订单金额 <span style="color: #f5222d; font-weight: 600;font-size: 24px;">¥${amount}</span> 进行支付
				                    </div>
				                </div>
				                
				                <p style="margin-bottom: 15px;">请使用微信扫描下方二维码支付：</p>
				                <div style="margin: 20px 0;">
				                    <div id="wechat-qrcode" style="min-height: 220px; display: flex; align-items: center; justify-content: center;"></div>
				                </div>
				                
				                <!-- 倒计时显示 -->
				                <div id="payment-timer" style="margin: 15px 0; font-size: 16px; color: #f5222d; font-weight: 600;">
				                    支付倒计时: <span id="time-left">${timeoutMinutes}:00</span>
				                </div>
				                
				                <!-- 订单信息 -->
				                <div style="background: #f5f7fa; border-radius: 6px; padding: 12px; margin: 15px 0; text-align: left;">
				                    <div style="margin-bottom: 6px;">
				                        <span style="color: #666; font-size: 12px;">商户订单号:</span>
				                        <span style="color: #333; font-weight: 500; margin-left: 8px;">${merchantOrderId}</span>
				                    </div>
				                    <div>
				                        <span style="color: #666; font-size: 12px;">创建时间:</span>
				                        <span style="color: #333; font-weight: 500; margin-left: 8px;">${createdTime}</span>
				                    </div>
				                </div>
				            </div>
				        `, '微信支付', {
							dangerouslyUseHTMLString: true,
							showConfirmButton: false,
							showCloseButton: true,
							customClass: 'wechat-pay-dialog',
							closeOnClickModal: false,
							closeOnPressEscape: false,
							beforeClose: (action, instance, done) => {
								// 在弹窗关闭时清理计时器
								if (this.paymentCountdownTimer) {
									clearInterval(this.paymentCountdownTimer);
								}
								done();
							}
						});
						loadingInstance.close()
						// 3. 延迟生成二维码，确保DOM已渲染
						setTimeout(() => {
							const element = document.getElementById('wechat-qrcode');
							if (element) {
								try {
									new QRCode(element, {
										text: payUrl,
										width: 200,
										height: 200,
										colorDark: "#000000",
										colorLight: "#ffffff",
										correctLevel: QRCode.CorrectLevel.H
									});
								} catch (error) {
									console.error('生成二维码失败:', error);
									element.innerHTML = `
				                        <div style="text-align: center;">
				                            <div style="color: #f56c6c; margin-bottom: 10px;">
				                                <i class="el-icon-error" style="font-size: 48px;"></i>
				                                <div style="margin-top: 10px;">二维码生成失败</div>
				                            </div>
				                            <div style="font-size: 12px; color: #909399;">
				                                请手动复制链接支付
				                            </div>
				                        </div>`;
								}
							} else {
								console.error('二维码容器元素未找到');
							}
							// 4. 开始倒计时
							this.startPaymentCountdown(timeoutMinutes, alertInstance);
						}, 300);

					} catch (error) {
						loadingInstance.close()
						console.error('处理微信支付失败:', error);
						this.$message.error('支付处理失败，请手动复制链接');

						// 显示备用弹窗，同样包含订单信息和倒计时
						this.showPaymentInfo(amount, merchantOrderId, createdTime, timeoutMinutes);
					}
				},
				// 添加倒计时方法
				startPaymentCountdown(timeoutMinutes, alertInstance) {
					// 清除已有的计时器
					if (this.paymentCountdownTimer) {
						clearInterval(this.paymentCountdownTimer);
					}

					let totalSeconds = timeoutMinutes * 60;

					// 更新倒计时显示
					const updateTimerDisplay = () => {
						const minutes = Math.floor(totalSeconds / 60);
						const seconds = totalSeconds % 60;
						const timeLeftElement = document.getElementById('time-left');

						if (timeLeftElement) {
							timeLeftElement.textContent = `${minutes}:${seconds.toString().padStart(2, '0')}`;
						}
					};

					// 初始显示
					updateTimerDisplay();

					// 启动倒计时
					this.paymentCountdownTimer = setInterval(() => {
						totalSeconds--;
						// 更新显示
						updateTimerDisplay();

						// 倒计时结束
						if (totalSeconds <= 0) {
							clearInterval(this.paymentCountdownTimer);

							// 关闭弹窗
							if (alertInstance) {
								alertInstance.close();
							}

							this.$message.warning({
								message: '支付超时，订单已关闭',
								duration: 3000
							});

							// 可选：调用后端关闭订单接口
							// this.closePaymentOrder();
						}
					}, 1000);
				},
				// 新增方法：确保QRCode库已加载
				async ensureQRCodeLibrary() {
					return new Promise((resolve, reject) => {
						if (typeof QRCode !== 'undefined') {
							resolve();
							return;
						}

						const script = document.createElement('script');
						script.src = 'https://cdn.bootcdn.net/ajax/libs/qrcodejs/1.0.0/qrcode.min.js';
						script.onload = () => {
							console.log('QRCode库加载成功');
							resolve();
						};
						script.onerror = (error) => {
							console.error('QRCode库加载失败:', error);
							reject(new Error('QRCode库加载失败'));
						};
						document.head.appendChild(script);
					});
				},

				// 开始轮询检查支付状态
				startPaymentCheck(result) {
					if (this.paymentTimer) {
						clearInterval(this.paymentTimer);
					}
					let checkCount = 0;
					const maxChecks = 60; // 最多检查60次（3分钟，假设每3秒一次）
					const timeout = result.data.timeOut || 3; // 使用返回的timeout值，单位：分钟

					this.paymentTimer = setInterval(() => {
						checkCount++;

						// 调用查询订单状态接口
						this.checkOrderStatus(result.data.orderId, result).then(status => {
							if (status === 1) { // 假设1表示兑换成功
								clearInterval(this.paymentTimer);
								this.$message.success('兑换成功！');
								this.closePaymentDialog(); // 关闭支付弹窗
								alertInstance.close()
							} else if (status === 2) { // 假设2表示支付失败
								clearInterval(this.paymentTimer);
								this.$message.error('支付失败或已取消');
							}
						}).catch(() => {
							// 查询失败，继续尝试
						});

						// 超过最大检查次数或超时
						if (checkCount >= maxChecks) {
							clearInterval(this.paymentTimer);
							this.$message.warning('支付超时，请检查支付状态');
						}
					}, 5000); // 每3秒检查一次
				},
				closePaymentDialog() {
					// 关闭所有可能的支付相关弹窗
					this.$msgbox.close(); // 关闭自定义消息框

					// 如果需要关闭特定弹窗，可以在这里添加
					// 例如：this.paymentDialogVisible = false;

					console.log('支付弹窗已关闭');
				},
				// 查询订单状态
				checkOrderStatus(payId, result) {
					return new Promise((resolve, reject) => {
						fetch(
								`checkorder.php?id=${payId}&payId=${result.data.payId}&price=${result.data.price}&uid=${this.userId}`
							)
							.then(response => response.json())
							.then(result => {
								if (result.code === 1 && result.data) {
									resolve(result.code); // 返回订单状态
								} else {
									reject();
								}
							})
							.catch(reject);
					});
				},

				// 播放成功音效
				playSuccessSound() {
					try {
						const audioContext = new(window.AudioContext || window.webkitAudioContext)();
						const oscillator = audioContext.createOscillator();
						const gainNode = audioContext.createGain();

						oscillator.connect(gainNode);
						gainNode.connect(audioContext.destination);

						oscillator.frequency.setValueAtTime(523.25, audioContext.currentTime);
						oscillator.frequency.setValueAtTime(659.25, audioContext.currentTime + 0.1);
						oscillator.frequency.setValueAtTime(783.99, audioContext.currentTime + 0.2);

						gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
						gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.3);

						oscillator.start(audioContext.currentTime);
						oscillator.stop(audioContext.currentTime + 0.3);
					} catch (e) {
						console.log('音频播放失败，不影响主要功能');
					}
				},
				// 获取用户类型（如果需要的话）
				getUserType() {
					const userType = localStorage.getItem('user_type')
					if (userType) {
						return parseInt(userType)
					}

					try {
						const userInfo = localStorage.getItem('user_info')
						if (userInfo) {
							const user = JSON.parse(userInfo)
							return user.user_type || 2 // 默认返回2（普通用户）
						}
					} catch (error) {
						console.error('读取用户类型失败:', error)
					}

					return 2
				},
				// 获取用户余额（优化版）
				getUserBalance() {
					// 先从直接存储的字段获取
					const balance = localStorage.getItem('user_balance')
					if (balance) {
						return this.formatBalance(balance)
					}

					// 备用：从user_info对象获取
					try {
						const userInfo = localStorage.getItem('user_info')
						if (userInfo) {
							const user = JSON.parse(userInfo)
							return this.formatBalance(user.balance || '0.00')
						}
					} catch (error) {
						console.error('读取用户余额失败:', error)
					}

					return '0.00'
				},
				// 获取用户手机号（优化版）
				getUserPhone() {
					// 先从直接存储的字段获取
					const mobile = localStorage.getItem('user_mobile')
					if (mobile) {
						return this.formatPhoneNumber(mobile)
					}

					// 备用：从user_info对象获取
					try {
						const userInfo = localStorage.getItem('user_info')
						if (userInfo) {
							const user = JSON.parse(userInfo)
							return this.formatPhoneNumber(user.mobile || '')
						}
					} catch (error) {
						console.error('读取用户手机号失败:', error)
					}

					return '未登录'
				},
				// 格式化手机号显示
				formatPhoneNumber(phone) {
					if (!phone) return ''
					const phoneStr = String(phone).replace(/\D/g, '') // 移除非数字字符
					if (phoneStr.length === 11) {
						return `${phoneStr.substring(0, 3)}${phoneStr.substring(3, 7)}${phoneStr.substring(7)}`
					}
					return phoneStr
				},
				// 格式化余额显示（添加千分位逗号）
				formatBalance(balance) {
					if (!balance) return '0.00'

					// 确保是字符串，移除可能的空格
					let balanceStr = String(balance).trim()

					// 分离整数和小数部分
					let [integerPart, decimalPart = '00'] = balanceStr.split('.')

					// 确保小数部分有两位
					if (decimalPart.length > 2) {
						decimalPart = decimalPart.substring(0, 2)
					} else if (decimalPart.length < 2) {
						decimalPart = decimalPart.padEnd(2, '0')
					}

					// 添加千分位逗号
					integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

					return `${integerPart}.${decimalPart}`
				},
				// 批量取消
				handleBatchCancel() {
					if (!this.batchButtons.cancel || this.selectedOrderIds.length === 0) return;

					this.$confirm(`确定要批量取消选中的 ${this.selectedOrderIds.length} 个订单吗？`, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						// 这里应该调用API批量取消订单
						console.log('批量取消的订单ID:', this.selectedOrderIds);

						// 模拟API调用
						this.$message.success(`成功取消 ${this.selectedOrderIds.length} 个订单`);

						// 清空选中状态
						this.selectedOrderIds = [];
						this.selectedOrders = [];

						// 刷新订单列表
						this.handleSearch();
					}).catch(() => {
						this.$message.info('已取消操作');
					});
				},

				// 批量确认
				handleBatchConfirm() {
					if (!this.batchButtons.confirm || this.selectedOrderIds.length === 0) return;

					this.$confirm(`确定要批量确认选中的 ${this.selectedOrderIds.length} 个订单吗？`, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						// 这里应该调用API批量确认订单
						console.log('批量确认的订单ID:', this.selectedOrderIds);

						// 模拟API调用
						this.$message.success(`成功确认 ${this.selectedOrderIds.length} 个订单`);

						// 清空选中状态
						this.selectedOrderIds = [];
						this.selectedOrders = [];

						// 刷新订单列表
						this.handleSearch();
					}).catch(() => {
						this.$message.info('已取消操作');
					});
				},

				// 批量签收
				handleBatchSign() {
					if (!this.batchButtons.sign || this.selectedOrderIds.length === 0) return;

					this.$confirm(`确定要批量签收选中的 ${this.selectedOrderIds.length} 个订单吗？`, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						// 这里应该调用API批量签收订单
						console.log('批量签收的订单ID:', this.selectedOrderIds);

						// 模拟API调用
						this.$message.success(`成功签收 ${this.selectedOrderIds.length} 个订单`);

						// 清空选中状态
						this.selectedOrderIds = [];
						this.selectedOrders = [];

						// 刷新订单列表
						this.handleSearch();
					}).catch(() => {
						this.$message.info('已取消操作');
					});
				},
				// 修改 handleStatusTabClick 方法，移除重复的搜索调用：
				async handleStatusTabClick(key) {
					// 设置活动标签
					this.activeTab = key;

					// 重置批量按钮状态
					this.batchButtons = {
						cancel: false,
						confirm: false,
						sign: false
					};

					// 清空选中
					this.selectedOrderIds = [];
					this.selectedOrders = [];

					// 根据状态标签设置搜索参数
					const statusMap = {
						'0': 0, // 全部
						'1': 1, // 待确认
						'2': 2, // 手动签收单
						'3': 3, // 待签收
						'4': 4, // 自动签收单
						'5': 5 // 已取消
					};

					// 更新搜索表单的状态
					this.searchForm.order_status = statusMap[key] || 0;

					// 重置分页到第一页
					this.currentPage = 1;

					// 更新批量按钮权限
					this.updateBatchButtonPermissions(key);

					// 重要：这里直接调用 handleSearch，而不是等待
					// 因为 handleSearch 是异步的，我们需要确保页面能加载
					this.handleSearch();
				},
				// 更新批量按钮权限
				updateBatchButtonPermissions(statusKey) {
					// 根据状态标签精准匹配权限
					switch (statusKey) {
						case '0': // 全部订单 - 根据选中订单的状态决定
							// 初始设为false，根据选中订单状态更新
							this.batchButtons = {
								cancel: false,
								confirm: false,
								sign: false
							};
							break;
						case '1': // 待确认
							this.batchButtons = {
								cancel: true,
								confirm: true,
								sign: false
							};
							break;
						case '2': // 手动签收单
						case '3': // 待签收
							this.batchButtons = {
								cancel: false,
								confirm: false,
								sign: true
							};
							break;
						case '4': // 已签收
						case '5': // 已取消
							this.batchButtons = {
								cancel: false,
								confirm: false,
								sign: false
							};
							break;
						default:
							this.batchButtons = {
								cancel: false,
								confirm: false,
								sign: false
							};
					}
				},
				//刷新余额
				async refreshBalance() {
					// 防止重复点击
					if (this.isRefreshingBalance) {
						return;
					}

					const userId = this.userId;
					if (!userId || userId === 0) {
						this.$message.error('用户未登录或用户ID无效');
						return;
					}

					// 保存当前余额值
					const originalBalance = this.userBalance;

					// 在余额数值上显示加载动画
					this.userBalance = '...';
					this.isRefreshingBalance = true;

					// 使用ref添加加载动画
					this.$nextTick(() => {
						if (this.$refs.balanceValue) {
							this.$refs.balanceValue.classList.add('loading-dots');
						}
					});

					try {
						// 使用统一的API请求函数
						const result = await this.apiRequest('/query_balance', {
							user_id: userId
						});

						if (result.code === 200) {
							// 更新余额显示
							this.userBalance = this.formatBalance(result.data.balance);

							// 同时更新localStorage中的余额信息
							localStorage.setItem('user_balance', result.data.balance);

							// 轻微的脉冲动画效果
							this.$nextTick(() => {
								if (this.$refs.balanceValue) {
									this.$refs.balanceValue.classList.add('pulse');
									setTimeout(() => {
										if (this.$refs.balanceValue) {
											this.$refs.balanceValue.classList.remove('pulse');
										}
									}, 500);
								}
							});

							this.$message({
								message: '余额刷新成功',
								type: 'success'
							});
						} else {
							// 恢复原来的余额值
							this.userBalance = originalBalance;
							this.$message.error(result.msg || '查询余额失败');
						}
					} catch (error) {
						// 恢复原来的余额值
						this.userBalance = originalBalance;
						// 错误消息已在apiRequest中显示
					} finally {
						// 移除加载动画
						this.$nextTick(() => {
							if (this.$refs.balanceValue) {
								this.$refs.balanceValue.classList.remove('loading-dots');
							}
						});

						this.isRefreshingBalance = false;
					}
				},
				// 新增：统一的API请求函数
				async apiRequest(url, data) {
					let shouldShowLoading = false;

					try {
						// 显示加载状态（根据URL判断）
						if (url.includes('query_orders')) {
							this.tableLoading = true;
						} else if (url.includes('query_balance')) {
							// 余额刷新有自己的状态处理
						} else if (url.includes('query_recharge')) {
							this.rechargeLoading = true;
							shouldShowLoading = true;
						}

						const response = await fetch(url, {
							method: 'POST',
							headers: {
								'Content-Type': 'application/json'
							},
							body: JSON.stringify(data)
						});

						if (!response.ok) {
							throw new Error(`HTTP错误! 状态码: ${response.status}`);
						}

						return await response.json();
					} catch (error) {
						console.error(`API请求失败 [${url}]:`, error);

						// 根据URL显示不同的错误消息
						if (url.includes('query_orders')) {
							this.$message.error('获取订单数据失败，请稍后重试');
						} else if (url.includes('query_balance')) {
							this.$message.error('获取余额失败');
						} else if (url.includes('query_recharge')) {
							this.$message.error('获取充值记录失败');
						} else {
							this.$message.error('网络请求失败');
						}

						throw error;
					} finally {
						// 确保加载状态被重置
						if (url.includes('query_orders')) {
							setTimeout(() => {
								this.tableLoading = false;
							}, 300);
						} else if (url.includes('query_recharge') && shouldShowLoading) {
							setTimeout(() => {
								this.rechargeLoading = false;
							}, 300);
						}
					}
				},
				// 显示充值记录弹窗
				showRechargeDialog() {
					this.rechargeDialogVisible = true;
					this.loadRechargeRecords();
				},

				// 加载充值记录
				async loadRechargeRecords() {
					this.rechargeLoading = true;

					// 获取用户ID
					const userId = this.userId;
					if (!userId || userId === 0) {
						this.$message.error('用户未登录或用户ID无效');
						this.rechargeLoading = false;
						return;
					}

					try {
						// 使用统一的API请求函数
						const result = await this.apiRequest('/query_recharge', {
							user_id: userId
						});

						if (result.code === 200) {
							// 处理返回的数据
							this.rechargeRecords = this.formatRechargeData(result.data.list || []);
							this.rechargeTotal = result.data.count || 0;
							// 如果没有数据，显示提示
							if (this.rechargeRecords.length === 0) {
								this.$message.info('暂无充值记录');
							}
						} else {
							this.$message.error(result.msg || '查询失败');
							this.rechargeRecords = [];
							this.rechargeTotal = 0;
						}
					} catch (error) {
						// 错误已在apiRequest方法中统一处理
						this.rechargeRecords = [];
						this.rechargeTotal = 0;
					} finally {
						this.rechargeLoading = false;
					}
				},
				// 降级方案：生成CSV文件
				downloadResultAsCSV() {
					if (!this.exportResult || !this.exportResult.assigned_track_numbers) {
						return;
					}

					this.$message.info('正在生成CSV文件...');

					try {
						// 创建CSV内容
						const headers = [
							'序号',
							'商户订单号',
							'系统订单号',
							'订单ID',
							'物流单号',
							'物流商',
							'分配状态',
							'分配时间',
							'扣费单价(积分)'
						];

						const rows = [];

						// 获取原始数据
						const originalData = this.allExcelData || this.excelPreviewData || [];

						originalData.forEach((row, index) => {
							// 查找物流单号（按索引匹配）
							const trackInfo = this.exportResult.assigned_track_numbers[index] || {};

							const rowData = [
								index + 1,
								`"${row.merchantOrderNo || row.merchant_order_no || row['商户订单号'] || ''}"`,
								`"${trackInfo.order_number || ''}"`,
								`"${trackInfo.order_id || ''}"`,
								`"${trackInfo.track_num || ''}"`,
								`"${this.exportResult.track_type_name || this.exportResult.deduction_detail.track_type_name || 'JCEX'}"`,
								`"${trackInfo.track_num ? '已分配' : '未分配'}"`,
								`"${new Date().toLocaleString('zh-CN')}"`,
								this.exportResult.unit_price || this.exportResult.deduction_detail.unit_price ||
								2
							];

							rows.push(rowData.join(','));
						});

						const csvContent = [headers.join(','), ...rows].join('\n');
						const blob = new Blob(['\ufeff' + csvContent], {
							type: 'text/csv;charset=utf-8'
						});
						const url = URL.createObjectURL(blob);
						const link = document.createElement('a');

						const fileName = `订单导入结果_${new Date().getTime()}.csv`;
						link.href = url;
						link.download = fileName;
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						URL.revokeObjectURL(url);

						this.$message.success(`CSV文件下载成功: ${fileName}`);

					} catch (error) {
						console.error('生成CSV失败:', error);
						this.$message.error('CSV文件生成失败');

						// 最后方案：只下载物流单号
						this.downloadTrackNumbersOnly();
					}
				},
				// 格式化充值记录数据
				formatRechargeData(data) {
					return data.map(item => {
						// 格式化充值金额
						const amount = parseFloat(item.recharge_amount || 0);
						const formattedAmount = amount.toFixed(2);

						// 格式化充值时间
						const rechargeTime = item.recharge_time || '';
						let formattedTime = '';
						try {
							const date = new Date(rechargeTime);
							if (!isNaN(date.getTime())) {
								// 格式化为 "YYYY-MM-DD HH:MM:SS"
								const year = date.getFullYear();
								const month = String(date.getMonth() + 1).padStart(2, '0');
								const day = String(date.getDate()).padStart(2, '0');
								const hours = String(date.getHours()).padStart(2, '0');
								const minutes = String(date.getMinutes()).padStart(2, '0');
								const seconds = String(date.getSeconds()).padStart(2, '0');
								formattedTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
							} else {
								formattedTime = rechargeTime;
							}
						} catch (e) {
							formattedTime = rechargeTime;
						}

						// 根据充值类型显示中文
						const rechargeType = parseInt(item.recharge_type || 1);
						const typeText = rechargeType === 1 ? '自动充值' : '手动充值';

						// 处理支付状态
						const payStatus = parseInt(item.pay_status || 1);
						const payStatusText = payStatus === 1 ? '兑换成功' :
							payStatus === 2 ? '支付失败' : '兑换失败';

						// 可以在这里添加用户账号信息（如果需要）
						const userPhone = this.userPhone || '未知账号';
						const displayAccount = userPhone === '未登录' ? '未知账号' : userPhone;

						return {
							id: item.id, // 主键ID
							order_id: item.order_id || '', // 订单ID
							user_id: item.user_id, // 用户ID
							account: displayAccount, // 显示用户账号
							amount: formattedAmount, // 充值金额
							time: formattedTime, // 充值时间
							type: typeText, // 充值类型（中文）
							recharge_type: rechargeType, // 充值类型（数字）
							pay_status: payStatus, // 支付状态（数字）
							pay_status_text: payStatusText, // 支付状态（中文）
							original_time: rechargeTime, // 保留原始时间，用于排序等操作
							// 注意：这里有两个 original_time，去掉重复的
						};
					});
				},
				// 只下载物流单号列表
				downloadTrackNumbersOnly() {
					if (!this.exportResult || !this.exportResult.assigned_track_numbers) {
						return;
					}

					const headers = ['序号', '订单号', '物流单号', '订单ID'];
					const rows = this.exportResult.assigned_track_numbers.map((item, index) => {
						return [
							index + 1,
							`"${item.order_number || ''}"`,
							`"${item.track_num || ''}"`,
							`"${item.order_id || ''}"`
						].join(',');
					});

					const csvContent = [headers.join(','), ...rows].join('\n');
					const blob = new Blob(['\ufeff' + csvContent], {
						type: 'text/csv;charset=utf-8'
					});
					const url = URL.createObjectURL(blob);
					const link = document.createElement('a');

					const fileName = `物流单号列表_${new Date().getTime()}.csv`;
					link.href = url;
					link.download = fileName;
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					URL.revokeObjectURL(url);

					this.$message.success(`物流单号列表下载成功: ${fileName}`);
				},
				// 刷新充值记录
				refreshRechargeRecords() {
					this.$message.info('正在刷新充值记录...');
					this.rechargeCurrentPage = 1;
					this.loadRechargeRecords();
				},

				// 充值记录分页大小变化
				handleRechargeSizeChange(val) {
					this.rechargePageSize = val;
					// 注意：如果需要后端分页，这里需要重新调用接口
					// 目前是前端分页，只更新显示
					this.rechargeCurrentPage = 1;
				},

				// 充值记录页码变化
				handleRechargeCurrentChange(val) {
					this.rechargeCurrentPage = val;
					// 注意：如果需要后端分页，这里需要重新调用接口
					// 目前是前端分页，只更新显示
				},

				// 退出登录（清空storage和cookie并刷新页面）
				handleLogout() {
					this.$confirm('确定要退出登录吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						// 清空localStorage
						localStorage.clear();

						// 清空sessionStorage
						sessionStorage.clear();

						// 清空cookie
						this.clearAllCookies();

						// 显示退出成功消息
						this.$message.success('退出登录成功！');

						// 延迟500ms后刷新页面
						setTimeout(() => {
							window.location.reload();
						}, 500);

					}).catch(() => {
						this.$message.info('已取消退出');
					});
				},

				// 清空所有cookie
				clearAllCookies() {
					const cookies = document.cookie.split(";");
					for (let i = 0; i < cookies.length; i++) {
						const cookie = cookies[i];
						const eqPos = cookie.indexOf("=");
						const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
						document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
						document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=" + window.location
							.hostname;
						document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=." + window.location
							.hostname;
					}
				},

				// 显示导入自动签收单弹窗
				showImportOrderDialog() {
					this.importDialogType = 'auto';
					this.importDialogVisible = true;
					// 打开弹窗时立即重置所有状态
					this.resetImportForm();
				},

				// 处理文件选择
				handleFileSelect(event) {
					const file = event.target.files[0];
					if (!file) {
						this.$refs.fileInput.value = '';
						return;
					}

					// 检查文件类型
					const validTypes = ['.xls', '.xlsx', 'application/vnd.ms-excel',
						'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
					];
					const fileExt = '.' + file.name.split('.').pop().toLowerCase();

					if (!validTypes.includes(fileExt) && !validTypes.includes(file.type)) {
						this.$message.error('请选择Excel文件 (.xls, .xlsx)');
						this.$refs.fileInput.value = '';
						return;
					}

					this.selectedFile = file;
					this.selectedFileName = file.name;

					// 自动读取并显示Excel内容
					this.readExcelFile(file);
				},
				// 在 methods 中找到 handleSearch 方法，修改如下：
				async handleSearch() {
					this.tableLoading = true;

					// 获取用户ID
					const userId = this.userId;
					if (!userId || userId === 0) {
						this.$message.error('用户未登录或用户ID无效');
						this.tableLoading = false;
						return;
					}

					try {
						// 验证并处理每页显示数量
						let pageSize;

						if (!this.pageSizeInput || this.pageSizeInput.trim() === '') {
							// 如果输入为空，使用默认值10
							pageSize = 10;
							this.pageSizeInput = '10'; // 更新输入框显示
						} else {
							pageSize = parseInt(this.pageSizeInput);

							// 验证有效性
							if (isNaN(pageSize) || pageSize < 1) {
								pageSize = 1;
								this.pageSizeInput = '1';
							} else if (pageSize > 1000) {
								pageSize = 1000;
								this.pageSizeInput = '1000';
							}
						}

						// 更新pageSize
						this.pageSize = pageSize;

						// 构建请求参数 - 明确包含 user_id
						const requestData = {
							merchant_order_no: this.searchForm.merchant_order_no || '',
							track_number: this.searchForm.track_number || '',
							track_type: this.searchForm.track_type || 0,
							order_status: this.searchForm.order_status || 0,
							create_time_start: this.searchForm.create_time_start || '',
							create_time_end: this.searchForm.create_time_end || '',
							track_start_time_start: this.searchForm.track_start_time_start || '',
							track_start_time_end: this.searchForm.track_start_time_end || '',
							track_end_time_start: this.searchForm.track_end_time_start || '',
							track_end_time_end: this.searchForm.track_end_time_end || '',
							user_id: userId, // 明确添加 user_id
							page: this.currentPage,
							page_size: this.pageSize
						};

						// 如果选择的是状态标签，覆盖搜索表单中的状态
						if (this.activeTab !== '0') {
							requestData.order_status = parseInt(this.activeTab);
						}

						// 使用统一的API请求函数（注意：这里不需要再声明result变量）
						const result = await this.apiRequest('/query_orders', requestData);

						if (result.code === 200) {
							// 确保数据存在
							const orders = result.data.orders || [];
							const pagination = result.data.pagination || {};

							// 格式化数据
							this.orderTableData = this.formatOrderData(orders);
							this.total = pagination.total || 0;

							// 如果没有数据，显示提示
							if (this.orderTableData.length === 0) {
								this.$message.info('未找到符合条件的订单');
							}
						} else {
							this.$message.error(result.msg || '查询失败');
							this.orderTableData = [];
							this.total = 0;
						}
					} catch (error) {
						console.error('查询订单失败:', error);
						this.$message.error('网络错误或服务器异常，请稍后重试');
						this.orderTableData = [];
						this.total = 0;
					} finally {
						this.tableLoading = false;
					}
				},
				// 新增：更新状态数量统计
				updateStatusCounts(orderData) {
					// 重置计数
					this.resetStatusCounts();

					// 统计各状态数量
					orderData.forEach(order => {
						if (order.status && this.orderStatusCounts.hasOwnProperty(order.status)) {
							this.orderStatusCounts[order.status]++;
						}
					});

					// 计算总数
					this.orderStatusCounts.total = orderData.length;

					// 更新状态标签的显示数量
					this.updateStatusListCounts();
				},
				// 确保重置方法正确工作：
				resetStatusCounts() {
					// 重置为0
					Object.keys(this.orderStatusCounts).forEach(key => {
						this.orderStatusCounts[key] = 0;
					});

					// 更新状态标签显示
					this.updateStatusListCounts();
				},
				// 确保正确更新显示：
				updateStatusListCounts() {
					// 更新状态标签的数量
					this.statusList = this.statusList.map(item => {
						if (item.key === '0') {
							// 全部订单使用 orderStatusCounts.total
							return {
								...item,
								count: this.orderStatusCounts.total
							};
						} else if (this.orderStatusCounts.hasOwnProperty(item.key)) {
							// 各状态订单显示对应数量
							return {
								...item,
								count: this.orderStatusCounts[item.key]
							};
						}
						return item;
					});
				},
				// 处理每页显示数量输入
				handlePageSizeInput(value) {
					// 只允许输入数字
					this.pageSizeInput = value.replace(/[^\d]/g, '');

					// 限制最大最小值
					if (this.pageSizeInput) {
						const num = parseInt(this.pageSizeInput);
						if (num < 1) {
							this.pageSizeInput = '1';
						} else if (num > 1000) {
							this.pageSizeInput = '1000';
						}
					}

					// 如果是空字符串，保持为空（这样placeholder能显示）
					if (this.pageSizeInput === '') {
						return;
					}
				},
				// 同时修改 formatOrderData 方法，确保 status 字段正确处理
				formatOrderData(orders) {
					if (!orders || !Array.isArray(orders)) {
						return [];
					}

					return orders.map(order => {
						// 确保 order_status 有值
						const orderStatus = order.order_status != null ? String(order.order_status) : '0';

						// 解析发货地址
						const formattedSenderAddress = this.parseAddress(order.shipping_address);
						// 解析收货地址
						const formattedReceiverAddress = this.parseAddress(order.receiving_address);

						return {
							id: order.id,
							merchantOrderNo: order.merchant_order_no || '',
							providerOrderNo: order.track_num || '',
							orderType: order.track_type != null ? String(order.track_type) : '0',
							senderAddress: order.shipping_address || '',
							formattedSenderAddress: formattedSenderAddress,
							receiverAddress: order.receiving_address || '',
							formattedReceiverAddress: formattedReceiverAddress,
							status: orderStatus, // 使用处理后的 status
							createTime: this.formatDateTime(order.create_time) || '',
							trackStartTime: this.formatDateTime(order.track_start_time) || '',
							trackEndTime: this.formatDateTime(order.track_end_time) || '',
							remark: order.remark || '',
							_raw: order
						};
					});
				},
				// 格式化日期时间
				formatDateTime(datetime) {
					if (!datetime) return '';

					try {
						const date = new Date(datetime);
						if (isNaN(date.getTime())) {
							return datetime; // 返回原始字符串
						}

						// 格式化为：YYYY-MM-DD HH:mm:ss
						const year = date.getFullYear();
						const month = String(date.getMonth() + 1).padStart(2, '0');
						const day = String(date.getDate()).padStart(2, '0');
						const hours = String(date.getHours()).padStart(2, '0');
						const minutes = String(date.getMinutes()).padStart(2, '0');
						const seconds = String(date.getSeconds()).padStart(2, '0');

						return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
					} catch (error) {
						console.error('格式化日期失败:', error);
						return datetime;
					}
				},
				// 在 methods 中找到 loadAllStatusCounts 方法，修改为：
				async loadAllStatusCounts() {
					try {
						const userId = this.userId;

						if (!userId || userId === 0) {
							console.error('用户ID无效，无法加载状态统计');
							return;
						}

						// 调用专门的统计接口
						const requestData = {
							user_id: userId // 确保这里有 user_id
						};


						const response = await fetch('/query_order_stats.php', {
							method: 'POST',
							headers: {
								'Content-Type': 'application/json',
							},
							body: JSON.stringify(requestData)
						});

						if (!response.ok) {
							throw new Error(`HTTP error! status: ${response.status}`);
						}

						const result = await response.json();


						if (result.code === 200) {
							const stats = result.data;


							// 更新状态标签的数量
							// 全部订单
							this.updateStatusListItem('0', stats.total);

							// 手动签收单 (status=2)
							this.updateStatusListItem('2', stats.manual_sign);

							// 自动签收单 (status=4)
							this.updateStatusListItem('4', stats.auto_sign);

							// 保存到本地缓存
							this.cachedStatusData = {
								stats: stats,
								timestamp: Date.now()
							};


						} else {
							console.error('获取状态统计失败:', result.msg);
							// 如果失败，显示默认值
							this.$message.error('获取订单统计失败');
						}
					} catch (error) {
						console.error('加载状态统计失败:', error);
						this.$message.error('加载统计信息失败，请检查网络连接');
					}
				},
				// 修改 calculateStatusCounts 方法
				calculateStatusCounts(orders) {

					// 重置计数
					const counts = {
						'1': 0, // 待确认
						'2': 0, // 手动签收单
						'3': 0, // 待签收
						'4': 0, // 自动签收单
						'5': 0 // 已取消
					};

					// 统计各状态数量
					if (orders && Array.isArray(orders)) {
						orders.forEach((order, index) => {
							if (order && order.order_status != null) {
								const status = String(order.order_status);
								if (counts.hasOwnProperty(status)) {
									counts[status]++;
								}
							}
						});
					}


					// 更新状态标签的数量
					Object.keys(counts).forEach(statusKey => {
						this.updateStatusListItem(statusKey, counts[statusKey]);
					});
				},
				// 新增：更新单个状态标签的数量
				updateStatusListItem(key, count) {
					const index = this.statusList.findIndex(item => item.key === key);
					if (index !== -1) {
						this.$set(this.statusList, index, {
							...this.statusList[index],
							count: count
						});
					}
				},
				// 修改地址解析方法 - 使用英文逗号分隔
				parseAddress(addressString) {
					if (!addressString || typeof addressString !== 'string') {
						return null;
					}

					// 去除首尾空格
					addressString = addressString.trim();

					// 使用英文逗号分割，但要注意地址中可能也包含逗号
					const parts = addressString.split(',').map(part => part.trim());

					// 根据后端返回的格式："州, 城市, 邮编, 地址"
					if (parts.length >= 4) {
						// 格式：州，城市，邮编，地址（可能地址中有逗号，所以取最后一部分为地址）
						const state = parts[0];
						const city = parts[1];
						const zipcode = parts[2];
						// 地址部分：将剩余的部分合并（因为地址中可能包含逗号）
						const address = parts.slice(3).join(', ').trim();

						return {
							state: state,
							city: city,
							zipcode: zipcode,
							address: address
						};
					} else if (parts.length === 3) {
						// 可能缺少邮编或其他情况
						return {
							state: parts[0] || '-',
							city: parts[1] || '-',
							zipcode: '-',
							address: parts[2] || '-'
						};
					} else if (parts.length === 2) {
						// 只有两个部分的情况
						return {
							state: parts[0] || '-',
							city: '-',
							zipcode: '-',
							address: parts[1] || '-'
						};
					} else {
						// 只有一个部分或其他格式
						return {
							state: '-',
							city: '-',
							zipcode: '-',
							address: addressString
						};
					}
				},
				// 更新状态标签数量（暂时保持原有逻辑，后续可以优化）
				updateStatusCounts() {
					// 这里可以从接口返回的统计数据中更新，暂时保持原有逻辑
					// 如果需要后端提供各状态数量，需要修改接口
				},
				// 重置搜索表单
				handleReset() {
					this.searchForm = {
						merchant_order_no: '',
						track_number: '',
						track_type: 0,
						order_status: 0,
						create_time_start: '',
						create_time_end: '',
						track_start_time_start: '',
						track_start_time_end: '',
						track_end_time_start: '',
						track_end_time_end: ''
					};
					this.pageSizeInput = ''; // 重置为空，显示placeholder
					this.pageSize = 10; // 重置为默认值10
					this.activeTab = '0';
					this.currentPage = 1;
					this.handleSearch();
				},
				//状态
				getStatusTagType(status) {
					switch (status) {
						case '1': // 待确认
							return 'warning';
						case '2': // 手动签收单
							return 'primary';
						case '3': // 待签收
							return 'info';
						case '4': // 自动签收单
							return 'success';
						case '5': // 已取消
							return 'danger';
						default:
							return '';
					}
				},

				handleCurrentChange(val) {
					this.currentPage = val;
					this.handleSearch();
				},
				// 在 methods 中添加：
				refreshStatusStats() {
					this.loadAllStatusCounts();
				}
			},
			// 修改created钩子函数
			async created() {
				try {

					// 检查登录状态
					const token = localStorage.getItem('token')
					const userId = this.getUserId()


					if (!token || userId === 0) {
						this.$message.warning('请先登录')
						this.$router.push('/')
						return
					}

					// 检查token是否过期
					const tokenExpire = localStorage.getItem('token_expire')
					if (tokenExpire && Date.now() > tokenExpire * 1000) {
						this.$message.warning('登录已过期，请重新登录')
						this.$router.push('/Login')
						return
					}

					// 设置用户ID到组件实例
					this.userId = userId;

					// 第一步：加载状态统计数据（使用大page_size）
					await this.loadAllStatusCounts();

					// 第二步：设置默认标签
					this.activeTab = '0';
					this.searchForm.order_status = 0;

					// 第三步：更新批量按钮权限
					this.updateBatchButtonPermissions('0');

					// 第四步：执行初始搜索（显示第一页数据）
					await this.handleSearch();

				} catch (error) {
					console.error('页面初始化失败:', error);
					this.$message.error('页面初始化失败，请刷新重试');
				} finally {}
			}
		};
	</script>
	<style>
		/* 在 Home.vue 的 style 部分添加 */
		.validation-dialog .el-message-box__message {
			max-height: 500px;
			overflow-y: auto;
		}

		.validation-dialog .el-message-box__status {
			top: 20px;
		}

		.validation-result .summary {
			background: #f6ffed;
			border: 1px solid #b7eb8f;
			border-radius: 6px;
			padding: 15px;
			margin-bottom: 15px;
		}

		.validation-result .summary p {
			margin: 5px 0;
			font-size: 14px;
		}

		.validation-result .error-section,
		.validation-result .warning-section {
			margin-top: 15px;
			padding: 10px;
			border-radius: 6px;
		}

		.validation-result .error-section {
			background: #fff2f0;
			border: 1px solid #ffccc7;
		}

		.validation-result .warning-section {
			background: #fffbe6;
			border: 1px solid #ffe58f;
		}

		.error-item:hover,
		.warning-item:hover {
			background: rgba(0, 0, 0, 0.02);
		}

		.address-cell {
			max-width: 200px;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			cursor: pointer;
		}

		.address-cell:hover {
			color: #409EFF;
		}

		/* 搜索表单中的选择器样式 */
		.search-input.order-type :deep(.el-input__inner) {
			height: 44px !important;
			line-height: 44px !important;
			padding-left: 40px !important;
		}

		.search-input.order-type :deep(.el-input__prefix) {
			left: 10px !important;
			top: 50% !important;
			transform: translateY(-50%) !important;
		}

		.search-input.order-type :deep(.el-icon-s-operation) {
			font-size: 16px !important;
			color: #909399 !important;
		}

		/* 全局样式重置 */
		.app-container {
			width: 100%;
			min-height: 100vh;
			background: linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%);
			box-sizing: border-box;
		}

		/* 顶部导航栏 */
		.header-nav {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 24px;
			height: 60px;
			background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
			box-shadow: 0 4px 20px rgba(102, 126, 234, 0.2);
			position: relative;
			z-index: 100;
		}

		.header-left {
			display: flex;
			align-items: center;
			font-size: 18px;
			font-weight: 700;
			color: #fff;
			letter-spacing: 0.5px;
		}

		.logo-icon {
			margin-right: 12px;
			font-size: 24px;
			background: rgba(255, 255, 255, 0.2);
			width: 36px;
			height: 36px;
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
			backdrop-filter: blur(4px);
		}

		.header-right {
			display: flex;
			align-items: center;
			gap: 24px;
			font-size: 14px;
			color: rgba(255, 255, 255, 0.9);
		}

		.balance-item {
			display: flex;
			align-items: center;
			gap: 8px;
			background: rgba(255, 255, 255, 0.15);
			padding: 6px 12px;
			border-radius: 20px;
			backdrop-filter: blur(4px);
			transition: all 0.3s ease;
		}

		.balance-item:hover {
			background: rgba(255, 255, 255, 0.25);
		}

		.balance-label {
			color: #FFD700;
			font-weight: 700;
			font-size: 16px;
		}

		.balance-value {
			color: #fff;
			font-weight: 700;
			font-size: 16px;
		}

		.balance-text {
			color: rgba(255, 255, 255, 0.8);
			font-size: 12px;
		}

		.refresh-btn,
		.record-btn {
			color: rgba(255, 255, 255, 0.8) !important;
			padding: 0 4px;
			margin-left: 2px;
		}

		.refresh-btn:hover,
		.record-btn:hover {
			color: #fff !important;
		}

		.refresh-btn:hover {
			transform: rotate(180deg);
			transition: transform 0.5s ease;
		}

		.record-btn:hover {
			transform: translateY(-1px);
			transition: transform 0.3s ease;
		}

		.user-info {
			display: flex;
			align-items: center;
			gap: 8px;
		}

		.user-icon {
			font-size: 18px;
			color: rgba(255, 255, 255, 0.9);
		}

		.phone-number {
			font-weight: 500;
		}

		.logout-btn {
			color: rgba(255, 255, 255, 0.9) !important;
			padding: 8px 12px;
			border-radius: 6px;
			transition: all 0.3s ease;
		}

		.logout-btn:hover {
			color: #fff !important;
			background: rgba(255, 255, 255, 0.1);
		}

		/* 主内容区 */
		.home-container {
			padding: 24px;
			max-width: 1600px;
			margin: 0 auto;
		}

		/* 状态标签栏 */
		.status-tabs {
			display: flex;
			background: #fff;
			border-radius: 16px 16px 0 0;
			box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
			overflow: hidden;
			margin-bottom: 0;
			border: 1px solid #f0f0f0;
			border-bottom: none;
		}

		.status-tab-item {
			display: flex;
			align-items: center;
			padding: 16px 24px;
			background: #fff;
			cursor: pointer;
			position: relative;
			font-size: 14px;
			color: #666;
			transition: all 0.3s ease;
			flex: 1;
			justify-content: center;
			gap: 8px;
			border-right: 1px solid #f0f0f0;
		}

		.status-tab-item:last-child {
			border-right: none;
		}

		.status-tab-item:hover {
			background: #f8f9ff;
			color: #667eea;
		}

		.status-tab-item.active {
			background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
			color: #fff;
			transform: translateY(-1px);
			box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
		}

		.status-tab-item i {
			font-size: 16px;
		}

		.status-tab-item .badge {
			display: inline-block;
			min-width: 20px;
			height: 20px;
			line-height: 20px;
			text-align: center;
			background: #ff4d4f;
			color: #fff;
			border-radius: 10px;
			font-size: 12px;
			font-weight: 600;
			padding: 0 4px;
		}

		/* 批量操作按钮栏 - 修复按钮大小问题 */
		.batch-actions {
			display: flex;
			align-items: center;
			padding: 16px 20px;
			background: #fff;
			border: 1px solid #f0f0f0;
			border-top: none;
			gap: 12px;
			margin-bottom: 16px;
			border-radius: 0 0 16px 16px;
			box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
			flex-wrap: wrap;
		}

		/* 统一所有批量按钮的样式 */
		.batch-btn {
			padding: 10px 20px !important;
			font-size: 14px !important;
			border-radius: 8px !important;
			font-weight: 500 !important;
			transition: all 0.3s ease !important;
			box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1) !important;
			border: none !important;
			height: 40px !important;
			/* 统一按钮高度 */
			line-height: 20px !important;
			/* 确保文字垂直居中 */
			display: inline-flex !important;
			align-items: center !important;
			justify-content: center !important;
		}

		.batch-btn:hover {
			transform: translateY(-2px) !important;
			box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
		}

		/* 特定按钮的背景色 */
		.batch-btn.cancel {
			background: linear-gradient(135deg, #FF6B6B 0%, #FF8E8E 100%) !important;
			color: #fff !important;
		}

		.batch-btn.confirm {
			background: linear-gradient(135deg, #4FC3F7 0%, #6ED3FF 100%) !important;
			color: #fff !important;
		}

		.batch-btn.sign {
			background: linear-gradient(135deg, #81C784 0%, #9CD89F 100%) !important;
			color: #fff !important;
		}

		.batch-btn.import-order,
		.batch-btn.import-sign {
			background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
			color: #fff !important;
		}

		.batch-btn.export,
		.batch-btn.download {
			background: #f5f5f5 !important;
			color: #999 !important;
			box-shadow: none !important;
		}

		/* 搜索栏 - 修复输入框图标对齐问题 */
		.search-bar {
			background: #fff;
			border-radius: 16px;
			padding: 20px;
			margin-bottom: 24px;
			box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
		}

		.search-form {
			display: grid;
			grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
			gap: 16px;
			align-items: end;
		}

		.search-input {
			width: 100%;
		}

		/* 修复输入框图标对齐 */
		.search-input :deep(.el-input) {
			height: 44px;
		}

		.search-input :deep(.el-input__inner) {
			height: 44px !important;
			border-radius: 10px !important;
			border: 1px solid #e4e7ed !important;
			transition: all 0.3s ease !important;
			line-height: 44px !important;
			padding-left: 40px !important;
		}

		/* 修复图标位置 */
		.search-input :deep(.el-input__prefix) {
			left: 10px !important;
			top: 50% !important;
			transform: translateY(-50%) !important;
			line-height: 1 !important;
			height: auto !important;
		}

		.search-input :deep(.el-input__prefix i) {
			font-size: 16px !important;
			color: #909399 !important;
		}

		.search-input :deep(.el-input__inner:hover),
		.search-input :deep(.el-input__inner:focus) {
			border-color: #667eea !important;
			box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1) !important;
		}

		/* 修复日期选择器图标对齐 */
		.search-input.date-start :deep(.el-input__prefix),
		.search-input.date-end :deep(.el-input__prefix) {
			left: 10px !important;
			top: 50% !important;
			transform: translateY(-50%) !important;
		}

		/* 统一搜索和重置按钮的样式 */
		.search-btn,
		.reset-btn {
			height: 44px !important;
			padding: 0 24px !important;
			font-size: 14px !important;
			border-radius: 10px !important;
			font-weight: 500 !important;
			transition: all 0.3s ease !important;
			line-height: 44px !important;
		}

		.search-btn {
			background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
			border: none !important;
			color: #fff !important;
		}

		.search-btn:hover {
			transform: translateY(-2px) !important;
			box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3) !important;
		}

		.reset-btn {
			background: #f5f5f5 !important;
			color: #666 !important;
			border: 1px solid #e4e7ed !important;
		}

		.reset-btn:hover {
			background: #e8e8e8 !important;
			color: #333 !important;
		}

		/* 表格容器 */
		.table-container {
			background: #fff;
			border-radius: 16px;
			overflow: hidden;
			box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
			margin-bottom: 24px;
		}

		.order-table {
			--el-table-border-color: #f0f0f0;
			--el-table-row-hover-bg-color: #f8f9ff;
			border: none;
		}

		.order-table :deep(.el-table__header-wrapper) {
			border-bottom: 2px solid #f0f0f0;
		}

		.order-table :deep(.el-table__body tr:hover > td) {
			background: #f8f9ff !important;
		}

		/* 自定义空数据提示 */
		.empty-data {
			text-align: center;
			padding: 60px 20px;
			background: #fff;
			color: #999;
		}

		/* 分页容器 - 修复分页输入框大小 */
		.pagination-container {
			display: flex;
			justify-content: center;
			align-items: center;
			padding: 20px;
			background: #fff;
			border-radius: 16px;
			box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
		}

		/* 分页组件的全局样式修复 */
		.order-pagination :deep(.el-pagination__sizes) {
			margin-right: 15px !important;
		}

		.order-pagination :deep(.el-pagination__sizes .el-input) {
			width: 120px !important;
		}

		/* 修复分页输入框大小 */
		.order-pagination :deep(.el-input__inner) {
			height: 36px !important;
			/* 与分页按钮高度一致 */
			line-height: 36px !important;
			border-radius: 6px !important;
			font-size: 14px !important;
		}

		/* 修复分页按钮大小 */
		.order-pagination :deep(.el-pager li),
		.order-pagination :deep(.btn-prev),
		.order-pagination :deep(.btn-next) {
			min-width: 36px !important;
			height: 36px !important;
			line-height: 36px !important;
			font-size: 14px !important;
			border-radius: 6px !important;
		}

		/* 修复跳转输入框 */
		.order-pagination :deep(.el-pagination__jump) {
			margin-left: 10px !important;
		}

		.order-pagination :deep(.el-pagination__editor) {
			height: 36px !important;
			line-height: 36px !important;
			font-size: 14px !important;
			border-radius: 6px !important;
			width: 60px !important;
		}

		/* 修复总数显示 */
		.order-pagination :deep(.el-pagination__total) {
			font-size: 14px !important;
			margin-right: 15px !important;
		}

		/* 页脚版权信息 */
		.footer-copyright {
			text-align: center;
			padding: 24px 0;
			color: #999;
			font-size: 14px;
			margin-top: 40px;
			border-top: 1px solid #f0f0f0;
		}

		/* 充值记录弹窗样式 */
		.recharge-dialog :deep(.el-dialog) {
			border-radius: 16px;
			overflow: hidden;
		}

		.recharge-dialog :deep(.el-dialog__header) {
			background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
			padding: 20px;
			text-align: center;
		}

		.recharge-dialog :deep(.el-dialog__title) {
			color: #fff;
			font-size: 18px;
			font-weight: 600;
		}

		.recharge-dialog :deep(.el-dialog__headerbtn .el-dialog__close) {
			color: #fff;
			font-size: 20px;
		}

		.recharge-dialog :deep(.el-dialog__body) {
			padding: 20px;
		}

		.dialog-content {
			min-height: 200px;
		}

		.empty-recharge {
			text-align: center;
			padding: 40px 20px;
			color: #999;
		}

		.recharge-pagination {
			margin-top: 20px;
			display: flex;
			justify-content: center;
		}

		.recharge-dialog :deep(.el-dialog__footer) {
			padding: 15px 20px;
			border-top: 1px solid #f0f0f0;
		}

		/* 导入订单弹窗样式 */
		.import-order-dialog :deep(.el-dialog) {
			border-radius: 16px;
			overflow: hidden;
		}

		.import-order-dialog :deep(.el-dialog__header) {
			background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
			padding: 20px;
			text-align: center;
			border-bottom: 1px solid #f0f0f0;
		}

		.import-order-dialog :deep(.el-dialog__title) {
			color: #fff;
			font-size: 18px;
			font-weight: 600;
		}

		.import-order-dialog :deep(.el-dialog__headerbtn .el-dialog__close) {
			color: #fff;
			font-size: 20px;
		}

		.import-order-dialog :deep(.el-dialog__body) {
			padding: 0;
		}

		.import-content {
			padding: 20px;
		}

		/* 文件上传区域 */
		.file-upload-area {
			border: 2px dashed #dcdfe6;
			border-radius: 12px;
			padding: 40px 20px;
			text-align: center;
			cursor: pointer;
			transition: all 0.3s ease;
			background-color: #fafbfc;
			margin-bottom: 20px;
		}

		.file-upload-area:hover {
			border-color: #667eea;
			background-color: #f8f9ff;
		}

		.upload-icon {
			margin-bottom: 16px;
		}

		.upload-text {
			color: #606266;
		}

		.main-text {
			font-size: 16px;
			font-weight: 600;
			margin-bottom: 8px;
			color: #667eea;
		}

		.sub-text {
			font-size: 14px;
			color: #909399;
			margin-bottom: 4px;
		}

		.file-name {
			font-size: 13px;
			color: #c0c4cc;
			margin-top: 8px;
			font-style: italic;
		}

		/* 文件信息区域 */
		.file-info {
			background-color: #f8f9ff;
			border-radius: 8px;
			padding: 16px;
			margin-bottom: 20px;
			border-left: 4px solid #667eea;
		}

		.info-title {
			font-size: 14px;
			font-weight: 600;
			color: #667eea;
			margin-bottom: 8px;
		}

		.info-desc {
			font-size: 13px;
			color: #606266;
			margin-bottom: 8px;
		}

		.column-list {
			list-style: none;
			padding: 0;
			margin: 0;
			font-size: 12px;
			color: #909399;
			line-height: 1.6;
		}

		.column-list li {
			margin-bottom: 4px;
		}

		/* 下载模板区域 */
		.download-template {
			text-align: center;
			padding-top: 10px;
			border-top: 1px solid #f0f0f0;
		}

		.download-template :deep(.el-link) {
			font-size: 14px;
		}

		.import-order-dialog :deep(.el-dialog__footer) {
			padding: 15px 20px;
			border-top: 1px solid #f0f0f0;
		}

		/* 响应式设计 */
		@media (max-width: 1200px) {
			.home-container {
				padding: 16px;
			}

			.status-tab-item {
				padding: 12px 16px;
				font-size: 13px;
			}

			.batch-actions {
				padding: 12px 16px;
				gap: 8px;
			}

			.batch-btn {
				padding: 8px 16px !important;
				font-size: 13px !important;
				height: 36px !important;
			}

			/* 响应式调整分页 */
			.order-pagination :deep(.el-pagination) {
				display: flex !important;
				flex-wrap: wrap !important;
				justify-content: center !important;
			}

			.order-pagination :deep(.el-pagination__total),
			.order-pagination :deep(.el-pagination__sizes),
			.order-pagination :deep(.el-pagination__jump) {
				margin-bottom: 10px !important;
			}
		}

		@media (max-width: 768px) {
			.header-nav {
				padding: 0 16px;
			}

			.header-left .system-name {
				display: none;
			}

			.balance-text {
				display: none;
			}

			.status-tabs {
				flex-wrap: wrap;
			}

			.status-tab-item {
				flex: 1 0 50%;
				border-right: none;
				border-bottom: 1px solid #f0f0f0;
			}

			.search-form {
				grid-template-columns: 1fr;
			}

			.recharge-dialog :deep(.el-dialog),
			.import-order-dialog :deep(.el-dialog) {
				width: 95% !important;
				max-width: 95%;
			}

			/* 移动端分页简化 */
			.order-pagination :deep(.el-pagination__jump) {
				display: none !important;
			}

		}

		/* 方案一的样式 */
		.balance-item.loading {
			opacity: 0.8;
			position: relative;
		}

		.balance-item.loading::after {
			content: '';
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			width: 20px;
			height: 20px;
			border: 2px solid rgba(255, 255, 255, 0.3);
			border-top-color: #fff;
			border-radius: 50%;
			animation: balance-spin 1s linear infinite;
		}

		/* 方案二的样式 */
		.refresh-btn.rotating i {
			animation: rotate 1s linear infinite;
		}

		/* 方案三的样式 */
		.balance-value.loading-dots::after {
			content: '...';
			animation: dots 1.5s steps(4, end) infinite;
		}

		.balance-value.pulse {
			animation: pulse 0.5s ease-in-out;
		}

		/* 动画定义 */
		@keyframes balance-spin {
			to {
				transform: translate(-50%, -50%) rotate(360deg);
			}
		}

		@keyframes rotate {
			from {
				transform: rotate(0deg);
			}

			to {
				transform: rotate(360deg);
			}
		}

		@keyframes dots {

			0%,
			20% {
				content: '.';
			}

			40% {
				content: '..';
			}

			60%,
			100% {
				content: '...';
			}
		}

		@keyframes pulse {
			0% {
				transform: scale(1);
			}

			50% {
				transform: scale(1.1);
			}

			100% {
				transform: scale(1);
			}
		}

		@keyframes fadeInOut {
			0% {
				opacity: 0;
				transform: translateY(-10px);
			}

			20% {
				opacity: 1;
				transform: translateY(0);
			}

			80% {
				opacity: 1;
				transform: translateY(0);
			}

			100% {
				opacity: 0;
				transform: translateY(-10px);
			}
		}

		/* 充值记录弹窗按钮样式 */
		.recharge-dialog :deep(.el-dialog__footer) {
			padding: 15px 20px;
			border-top: 1px solid #f0f0f0;
			display: flex;
			justify-content: center;
			gap: 12px;
		}

		.dialog-btn {
			padding: 10px 24px !important;
			font-size: 14px !important;
			font-weight: 500 !important;
			border-radius: 8px !important;
			height: 40px !important;
			min-width: 100px !important;
			transition: all 0.3s ease !important;
		}

		.dialog-btn.cancel-btn {
			background: #f5f5f5 !important;
			color: #666 !important;
			border: 1px solid #e4e7ed !important;
		}

		.dialog-btn.cancel-btn:hover {
			background: #e8e8e8 !important;
			color: #333 !important;
			border-color: #dcdfe6 !important;
		}

		.dialog-btn.refresh-btn {
			background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
			border: none !important;
			color: #fff !important;
			box-shadow: 0 2px 6px rgba(102, 126, 234, 0.2) !important;
		}

		.dialog-btn.refresh-btn:hover {
			background: linear-gradient(135deg, #5a6fd8 0%, #6a4390 100%) !important;
			transform: translateY(-2px) !important;
			box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3) !important;
		}

		.dialog-btn.refresh-btn:active {
			transform: translateY(0) !important;
		}

		/* 当刷新按钮处于加载状态时 */
		.dialog-btn.refresh-btn.is-loading {
			opacity: 0.8;
			cursor: not-allowed;
		}

		/* 地址单元格样式 */
		.address-cell.formatted-address {
			max-width: 220px;
			text-align: left;
			padding: 8px;
			background: #f8f9ff;
			border-radius: 6px;
			border: 1px solid #e4e7ed;
			font-size: 12px;
			line-height: 1.5;
		}

		.address-line {
			margin-bottom: 2px;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		.address-line:last-child {
			margin-bottom: 0;
		}

		/* 备注单元格样式 */
		.remark-cell {
			padding: 8px;
			background: #f8f9ff;
			border-radius: 6px;
			border: 1px solid #e4e7ed;
			min-height: 40px;
			max-width: 200px;
		}

		.remark-text {
			font-size: 12px;
			color: #606266;
			line-height: 1.4;
			display: -webkit-box;
			-webkit-line-clamp: 3;
			-webkit-box-orient: vertical;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		/* 悬停提示样式 */
		.remark-cell:hover {
			border-color: #409EFF;
			background: #ecf5ff;
		}

		/* 响应式调整 */
		@media (max-width: 1200px) {

			.address-cell.formatted-address,
			.remark-cell {
				font-size: 11px;
				padding: 6px;
			}

			.address-line {
				line-height: 1.4;
			}
		}

		@media (max-width: 768px) {
			.address-cell.formatted-address {
				max-width: 150px;
			}

			.remark-cell {
				max-width: 120px;
				min-height: 35px;
			}

			.remark-text {
				font-size: 11px;
				-webkit-line-clamp: 2;
			}
		}

		/* 表格整体优化 */
		.table-container {
			background: #fff;
			border-radius: 8px;
			overflow: hidden;
			box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
			margin-bottom: 24px;
		}

		.order-table :deep(.el-table__header-wrapper) {
			border-bottom: 1px solid #ebeef5;
		}

		.order-table :deep(.el-table__body tr:hover > td) {
			background: #f5f7fa !important;
		}

		.order-table :deep(.el-table__body tr) {
			transition: background-color 0.3s ease;
		}

		.order-table :deep(.el-table__cell) {
			border-color: #ebeef5;
		}

		/* 通用单元格样式 */
		.simple-cell {
			padding: 4px 0;
		}

		.cell-text {
			color: #333;
			font-size: 13px;
			line-height: 1.5;
		}

		.remark {
			color: #333;
			/* 改为更深的灰色 */
			font-style: italic;
			font-weight: 500;
			/* 加粗一点 */
		}

		/* 地址单元格 */
		.address-cell {
			max-width: 200px;
			text-align: left;
		}

		.address-line {
			margin-bottom: 4px;
			display: flex;
			align-items: flex-start;
		}

		.address-line:last-child {
			margin-bottom: 0;
		}

		.address-label {
			display: inline-block;
			min-width: 40px;
			color: #666;
			font-size: 12px;
			margin-right: 4px;
		}

		.address-value {
			color: #333;
			font-size: 12px;
			font-weight: 500;
			flex: 1;
			word-break: break-word;
		}

		/* 状态标签基础样式 */
		.order-table :deep(.el-tag) {
			border: none;
			font-size: 12px;
			min-width: 80px;
			/* 添加最小宽度 */
			text-align: center;
			white-space: nowrap;
			/* 防止换行 */
			overflow: visible;
			/* 确保内容完全显示 */
		}

		/* 表格行悬停效果 */
		.order-table :deep(.el-table__row:hover .cell-text) {
			color: #409EFF;
		}

		.order-table :deep(.el-table__row:hover .address-value) {
			color: #409EFF;
		}

		/* 响应式调整 */
		@media (max-width: 1400px) {
			.order-table :deep(.el-table__cell) {
				padding: 8px 6px !important;
			}

			.address-cell {
				max-width: 180px;
			}

			.address-label {
				min-width: 36px;
				font-size: 11px;
			}

			.address-value {
				font-size: 11px;
			}

			.cell-text {
				font-size: 12px;
			}
		}

		@media (max-width: 1200px) {
			.address-cell {
				max-width: 160px;
			}

			.address-label {
				min-width: 34px;
			}

			.address-line {
				margin-bottom: 3px;
			}
		}

		@media (max-width: 992px) {
			.table-container {
				overflow-x: auto;
			}

			.order-table {
				min-width: 1400px;
			}
		}

		/* 顶部导航栏 - 使用同样的渐变背景 */
		.header-nav {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 24px;
			height: 60px;
			background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
			box-shadow: 0 4px 20px rgba(102, 126, 234, 0.2);
			position: relative;
			z-index: 100;
		}

		/* 状态标签栏 - 激活状态使用同样的渐变 */
		.status-tab-item.active {
			background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
			color: #fff;
			transform: translateY(-1px);
			box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
		}

		/* 批量操作按钮 - 使用对应的颜色 */
		.batch-btn.cancel {
			background: linear-gradient(135deg, #FF6B6B 0%, #FF8E8E 100%) !important;
			color: #fff !important;
		}

		.batch-btn.confirm {
			background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
			color: #fff !important;
		}

		.batch-btn.sign {
			background: linear-gradient(135deg, #81C784 0%, #9CD89F 100%) !important;
			color: #fff !important;
		}

		.batch-btn.import-order,
		.batch-btn.import-sign {
			background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
			color: #fff !important;
		}

		/* 搜索按钮 - 使用同样的渐变 */
		.search-btn {
			background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
			border: none !important;
			color: #fff !important;
		}

		/* 表格整体样式 */
		.table-container {
			background: #fff;
			border-radius: 8px;
			overflow: hidden;
			box-shadow: 0 2px 12px rgba(102, 126, 234, 0.1);
			margin-bottom: 24px;
			border: 1px solid #e4e7ed;
		}

		.order-table :deep(.el-table__header-wrapper) {
			border-bottom: 2px solid #667eea;
		}

		.order-table :deep(.el-table__body tr:hover > td) {
			background: #f8f9ff !important;
		}

		.order-table :deep(.el-table__body tr) {
			transition: background-color 0.3s ease;
		}

		.order-table :deep(.el-table__cell) {
			border-color: #e4e7ed;
		}

		/* 通用单元格样式 */
		.simple-cell {
			padding: 4px 0;
		}

		.cell-text {
			color: #333;
			font-size: 13px;
			line-height: 1.5;
		}

		.track-number {
			font-family: 'Courier New', monospace;
			color: #4a5cd6;
			/* 改为更深的蓝色 */
			font-weight: 600;
			/* 加粗一点 */
		}

		/* 地址单元格 */
		.address-cell {
			max-width: 200px;
			text-align: left;
		}

		.address-line {
			margin-bottom: 4px;
			display: flex;
			align-items: flex-start;
		}

		.address-line:last-child {
			margin-bottom: 0;
		}

		.address-label {
			display: inline-block;
			min-width: 40px;
			color: #666;
			font-size: 12px;
			margin-right: 4px;
		}

		.address-value {
			color: #333;
			font-size: 12px;
			font-weight: 500;
			flex: 1;
			word-break: break-word;
		}

		/* 状态标签样式 - 调整颜色与主题协调 */
		.order-table :deep(.el-tag--warning) {
			background-color: #fff6e6;
			border-color: #ffe7ba;
			color: #fa8c16;
		}

		.order-table :deep(.el-tag--primary) {
			background-color: #ecf5ff;
			border-color: #d9ecff;
			color: #667eea;
		}

		.order-table :deep(.el-tag--info) {
			background-color: #f4f4f5;
			border-color: #e9e9eb;
			color: #909399;
		}

		.order-table :deep(.el-tag--success) {
			background-color: #f0f9eb;
			border-color: #e1f3d8;
			color: #67c23a;
		}

		.order-table :deep(.el-tag--danger) {
			background-color: #fef0f0;
			border-color: #fde2e2;
			color: #f56c6c;
		}

		/* 物流商标签样式 */
		.order-table :deep(.el-tag.el-tag--primary) {
			background-color: #ecf5ff;
			border-color: #d9ecff;
			color: #667eea;
		}

		.order-table :deep(.el-tag.el-tag--success) {
			background-color: #f0f9eb;
			border-color: #e1f3d8;
			color: #67c23a;
		}

		/* 表格行悬停效果 - 使用主题色相关的浅色 */
		.order-table :deep(.el-table__row:hover .cell-text) {
			color: #667eea;
		}

		.order-table :deep(.el-table__row:hover .address-value) {
			color: #667eea;
		}

		.order-table :deep(.el-table__row:hover .track-number) {
			color: #764ba2;
		}

		/* 页码激活状态 - 使用主题色 */
		.order-pagination :deep(.el-pagination.is-background .el-pager li:not(.disabled).active) {
			background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
			color: #fff !important;
		}

		.order-pagination :deep(.el-pagination.is-background .el-pager li:not(.disabled):hover) {
			color: #667eea !important;
		}

		/* 充值记录弹窗头部 */
		.recharge-dialog :deep(.el-dialog__header),
		.import-order-dialog :deep(.el-dialog__header) {
			background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
			padding: 20px;
			text-align: center;
		}

		/* 弹窗按钮 */
		.dialog-btn.refresh-btn {
			background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
			border: none !important;
			color: #fff !important;
			box-shadow: 0 2px 6px rgba(102, 126, 234, 0.2) !important;
		}

		/* 响应式调整 */
		@media (max-width: 1400px) {
			.order-table :deep(.el-table__cell) {
				padding: 8px 6px !important;
			}

			.address-cell {
				max-width: 180px;
			}

			.address-label {
				min-width: 36px;
				font-size: 11px;
			}

			.address-value {
				font-size: 11px;
			}

			.cell-text {
				font-size: 12px;
			}
		}

		@media (max-width: 1200px) {
			.address-cell {
				max-width: 160px;
			}

			.address-label {
				min-width: 34px;
			}

			.address-line {
				margin-bottom: 3px;
			}
		}

		@media (max-width: 992px) {
			.table-container {
				overflow-x: auto;
			}

			.order-table {
				min-width: 1400px;
			}
		}

		/* 状态标签栏的徽章样式优化 */
		.status-tab-item .badge {
			display: inline-block;
			min-width: 20px;
			height: 20px;
			line-height: 20px;
			text-align: center;
			background: #ff4d4f;
			color: #fff;
			border-radius: 10px;
			font-size: 12px;
			font-weight: 600;
			padding: 0 6px;
			margin-left: 6px;
		}

		.status-tab-item.active .badge {
			background: rgba(255, 255, 255, 0.9);
			color: #764ba2;
		}

		/* 响应式调整徽章 */
		@media (max-width: 1200px) {
			.status-tab-item .badge {
				min-width: 18px;
				height: 18px;
				line-height: 18px;
				font-size: 11px;
				margin-left: 4px;
			}
		}

		@media (max-width: 768px) {
			.status-tab-item .badge {
				position: absolute;
				top: 4px;
				right: 4px;
				min-width: 16px;
				height: 16px;
				line-height: 16px;
				font-size: 10px;
			}
		}

		/* 每页显示输入框样式 */
		.search-input.page-size-input {
			width: 120px;
			/* 设置固定宽度 */
		}

		.search-input.page-size-input :deep(.el-input__inner) {
			height: 44px !important;
			border-radius: 10px !important;
			border: 1px solid #e4e7ed !important;
			text-align: center;
			padding: 0 15px !important;
		}

		/* 聚焦样式 */
		.search-input.page-size-input :deep(.el-input__inner:focus) {
			border-color: #667eea !important;
			box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1) !important;
		}

		/* 清空按钮样式 */
		.search-input.page-size-input :deep(.el-input__suffix) {
			right: 10px;
		}

		/* 响应式调整 */
		@media (max-width: 768px) {
			.search-input.page-size-input {
				width: 100px;
			}
		}

		@media (max-width: 480px) {
			.search-input.page-size-input {
				width: 80px;
			}

			.search-input.page-size-input :deep(.el-input__inner) {
				padding: 0 10px !important;
				font-size: 13px;
			}
		}

		/* 在样式部分添加以下CSS */

		/* 导入订单弹窗按钮样式 */
		.import-order-dialog :deep(.el-dialog__footer) {
			padding: 15px 20px;
			border-top: 1px solid #f0f0f0;
			display: flex;
			justify-content: center;
			gap: 12px;
		}

		/* 统一弹窗按钮样式 */
		.dialog-btn {
			padding: 10px 24px !important;
			font-size: 14px !important;
			font-weight: 500 !important;
			border-radius: 8px !important;
			height: 40px !important;
			min-width: 100px !important;
			transition: all 0.3s ease !important;
		}

		.dialog-btn.cancel-btn {
			background: #f5f5f5 !important;
			color: #666 !important;
			border: 1px solid #e4e7ed !important;
		}

		.dialog-btn.cancel-btn:hover {
			background: #e8e8e8 !important;
			color: #333 !important;
			border-color: #dcdfe6 !important;
		}

		.dialog-btn.import-btn {
			background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
			border: none !important;
			color: #fff !important;
			box-shadow: 0 2px 6px rgba(102, 126, 234, 0.2) !important;
		}

		.dialog-btn.import-btn:hover {
			background: linear-gradient(135deg, #5a6fd8 0%, #6a4390 100%) !important;
			transform: translateY(-2px) !important;
			box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3) !important;
		}

		.dialog-btn.import-btn:active {
			transform: translateY(0) !important;
		}

		/* 当导入按钮处于加载状态时 */
		.dialog-btn.import-btn.is-loading {
			opacity: 0.8;
			cursor: not-allowed;
		}

		/* 当导入按钮被禁用时 */
		.dialog-btn.import-btn.is-disabled {
			opacity: 0.5;
			cursor: not-allowed;
		}

		.dialog-btn.import-btn.is-disabled:hover {
			background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
			transform: none !important;
			box-shadow: 0 2px 6px rgba(102, 126, 234, 0.2) !important;
		}

		/* 修改批量操作按钮栏的样式 */
		.batch-actions {
			display: flex;
			justify-content: space-between;
			/* 左右分开 */
			align-items: center;
			padding: 16px 20px;
			background: #fff;
			border: 1px solid #f0f0f0;
			border-top: none;
			gap: 12px;
			margin-bottom: 16px;
			border-radius: 0 0 16px 16px;
			box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
			flex-wrap: wrap;
		}

		/* 左边的批量操作按钮容器 */
		.batch-left {
			display: flex;
			align-items: center;
			gap: 12px;
			flex-wrap: wrap;
			flex: 1;
		}

		/* 右边的导入按钮容器 */
		.batch-right {
			display: flex;
			align-items: center;
			gap: 12px;
			margin-left: auto;
			/* 自动推到右边 */
		}

		/* 或者使用flexbox的方式 */
		.batch-right {
			display: flex;
			align-items: center;
			gap: 12px;
		}

		/* 统一所有批量按钮的样式保持不变 */
		.batch-btn {
			padding: 10px 20px !important;
			font-size: 14px !important;
			border-radius: 8px !important;
			font-weight: 500 !important;
			transition: all 0.3s ease !important;
			box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1) !important;
			border: none !important;
			height: 40px !important;
			/* 统一按钮高度 */
			line-height: 20px !important;
			/* 确保文字垂直居中 */
			display: inline-flex !important;
			align-items: center !important;
			justify-content: center !important;
		}

		/* 特定按钮的背景色保持不变 */
		.batch-btn.import-order,
		.batch-btn.import-sign {
			background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
			color: #fff !important;
		}

		/* 响应式设计 */
		@media (max-width: 1200px) {
			.batch-actions {
				padding: 12px 16px;
				gap: 8px;
			}

			.batch-btn {
				padding: 8px 16px !important;
				font-size: 13px !important;
				height: 36px !important;
			}

			.batch-left,
			.batch-right {
				gap: 8px;
			}
		}

		@media (max-width: 768px) {
			.batch-actions {
				flex-direction: column;
				align-items: stretch;
			}

			.batch-left,
			.batch-right {
				width: 100%;
				justify-content: center;
				margin-left: 0;
				margin-bottom: 8px;
			}

			.batch-right {
				margin-top: 8px;
			}
		}

		.batch-btn.sign {
			background: linear-gradient(135deg, #00C853 0%, #64DD17 100%) !important;
			color: #fff !important;
		}

		.batch-btn.sign:hover {
			background: linear-gradient(135deg, #00B248 0%, #4CAF50 100%) !important;
			transform: translateY(-2px) !important;
			box-shadow: 0 4px 12px rgba(0, 200, 83, 0.4) !important;
		}

		.batch-btn.import-order,
		.batch-btn.import-sign {
			background: #2979FF !important;
			color: #fff !important;
			box-shadow: 0 3px 8px rgba(41, 121, 255, 0.4) !important;
		}

		.batch-btn.import-order:hover,
		.batch-btn.import-sign:hover {
			background: #2962FF !important;
			transform: translateY(-2px) !important;
			box-shadow: 0 5px 15px rgba(41, 121, 255, 0.5) !important;
		}

		/* 导入对话框中的物流商选择样式 */
		.provider-select-section {
			background: #f8f9ff;
			border-radius: 10px;
			padding: 16px;
			margin-bottom: 20px;
			border: 1px solid #e4e7ed;
		}

		.section-label {
			font-size: 15px;
			font-weight: 600;
			color: #333;
			margin-bottom: 12px;
			display: flex;
			align-items: center;
		}

		.section-content {
			margin-left: 8px;
		}

		.provider-select {
			width: 100%;
			margin-bottom: 8px;
		}

		.provider-select :deep(.el-input__inner) {
			height: 44px;
			border-radius: 8px;
			border: 1px solid #e4e7ed;
			font-size: 14px;
		}

		.select-tip {
			font-size: 12px;
			color: #909399;
			margin-top: 6px;
			display: flex;
			align-items: center;
		}

		/* 响应式调整 */
		@media (max-width: 768px) {
			.provider-select-section {
				padding: 12px;
			}

			.section-label {
				font-size: 14px;
			}

			.provider-select :deep(.el-input__inner) {
				height: 40px;
				font-size: 13px;
			}
		}

		/* Excel预览样式 */
		.excel-preview-section {
			background: #fff;
			border-radius: 10px;
			padding: 16px;
			margin-bottom: 20px;
			border: 1px solid #e4e7ed;
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
		}

		.stats-info {
			margin: 12px 0;
			padding: 12px;
			background: #f8f9ff;
			border-radius: 8px;
			border: 1px solid #e4e7ed;
		}

		.stat-item {
			text-align: center;
			padding: 8px;
		}

		.stat-value {
			font-size: 24px;
			font-weight: 700;
			color: #667eea;
			margin-bottom: 4px;
		}

		.stat-label {
			font-size: 12px;
			color: #909399;
		}

		.preview-table {
			margin: 16px 0;
		}

		.excel-preview-table {
			font-size: 12px;
		}

		.excel-preview-table :deep(.el-table__header-wrapper) {
			background: #f5f7fa;
		}

		.address-preview {
			line-height: 1.4;
		}

		.preview-tip {
			text-align: center;
			padding: 8px;
			font-size: 12px;
			color: #909399;
			background: #fafafa;
			border-top: 1px solid #ebeef5;
		}

		.preview-actions {
			display: flex;
			justify-content: center;
			gap: 12px;
			margin-top: 16px;
			padding-top: 16px;
			border-top: 1px solid #f0f0f0;
		}

		/* 加载状态 */
		.excel-loading {
			text-align: center;
			padding: 40px;
			color: #909399;
		}

		.excel-loading .el-icon-loading {
			font-size: 32px;
			margin-bottom: 16px;
			color: #667eea;
		}

		/* 在 Home.vue 的 style 部分添加或修改 */
		.stats-info {
			margin: 16px 0;
			padding: 20px;
			background: linear-gradient(135deg, #f8f9ff 0%, #f0f2ff 100%);
			border-radius: 12px;
			border: 1px solid #e6e8ff;
			box-shadow: 0 4px 12px rgba(102, 126, 234, 0.08);
		}

		.stat-item {
			text-align: center;
			padding: 10px;
			transition: transform 0.3s ease;
		}

		.stat-item:hover {
			transform: translateY(-3px);
		}

		.stat-value {
			font-size: 28px;
			font-weight: 700;
			color: #667eea;
			margin-bottom: 6px;
			text-shadow: 0 2px 4px rgba(102, 126, 234, 0.1);
		}

		.stat-label {
			font-size: 13px;
			color: #666;
			font-weight: 500;
			letter-spacing: 0.5px;
		}

		/* 平台分布显示样式 */
		.platform-distribution {
			margin-top: 20px;
			padding: 16px;
			background: #fff;
			border-radius: 10px;
			border: 1px solid #e4e7ed;
		}

		.platform-distribution-title {
			font-size: 14px;
			font-weight: 600;
			color: #333;
			margin-bottom: 12px;
			display: flex;
			align-items: center;
		}

		.platform-distribution-title i {
			color: #667eea;
			margin-right: 8px;
		}

		.platform-tags {
			display: flex;
			flex-wrap: wrap;
			gap: 8px;
		}

		.platform-tag {
			padding: 6px 12px;
			background: #f0f2ff;
			border-radius: 16px;
			font-size: 12px;
			color: #667eea;
			display: flex;
			align-items: center;
			transition: all 0.3s ease;
		}

		.platform-tag:hover {
			background: #667eea;
			color: #fff;
			transform: translateY(-1px);
			box-shadow: 0 3px 8px rgba(102, 126, 234, 0.3);
		}

		.platform-count {
			background: rgba(255, 255, 255, 0.2);
			border-radius: 10px;
			padding: 1px 6px;
			margin-left: 6px;
			font-size: 11px;
			font-weight: 600;
		}

		/* 响应式调整 */
		@media (max-width: 768px) {
			.stats-info {
				padding: 16px;
			}

			.stat-value {
				font-size: 24px;
			}

			.stat-label {
				font-size: 12px;
			}

			.platform-distribution {
				padding: 12px;
			}

			.platform-tag {
				padding: 5px 10px;
				font-size: 11px;
			}
		}

		@media (max-width: 480px) {
			.stats-info {
				padding: 12px;
			}

			.stat-value {
				font-size: 22px;
			}

			.el-row .el-col {
				margin-bottom: 10px;
			}
		}

		/* 导入确认弹窗样式 */
		.import-confirm-dialog .el-message-box__content {
			padding: 20px;
		}

		.import-confirm-content {
			text-align: center;
			padding: 15px 0;
		}

		.import-confirm-content .loading-icon {
			font-size: 40px;
			color: #409EFF;
			margin-bottom: 15px;
			animation: rotate 2s linear infinite;
		}

		.import-confirm-content .confirm-details {
			background: #f8f9ff;
			border-radius: 8px;
			padding: 15px;
			margin-top: 10px;
			border-left: 3px solid #409EFF;
		}

		.import-confirm-content .confirm-details p {
			margin: 8px 0;
			color: #666;
			font-size: 14px;
		}

		/* 确认按钮加载动画 */
		.import-confirm-dialog .el-button--primary.loading {
			position: relative;
			overflow: hidden;
		}

		.import-confirm-dialog .el-button--primary.loading::after {
			content: '';
			position: absolute;
			top: 50%;
			left: 50%;
			width: 20px;
			height: 20px;
			margin: -10px 0 0 -10px;
			border: 2px solid rgba(255, 255, 255, 0.3);
			border-top-color: #fff;
			border-radius: 50%;
			animation: spin 1s linear infinite;
		}

		.import-confirm-dialog .el-button--primary.loading span {
			visibility: hidden;
		}

		/* 成功动画样式 */
		.success-animation-container {
			text-align: center;
			padding: 10px 0;
		}

		.success-icon {
			position: relative;
			margin: 0 auto;
			width: 60px;
			height: 60px;
		}

		.success-checkmark {
			font-size: 60px;
			color: #52c41a;
			animation: scaleIn 0.5s ease-out, pulse 1.5s ease-in-out 0.5s infinite;
		}

		.success-text {
			margin: 15px 0;
		}

		.success-progress {
			width: 100%;
			height: 4px;
			background: #f0f0f0;
			border-radius: 2px;
			overflow: hidden;
			margin-top: 15px;
		}

		.success-progress .progress-bar {
			height: 100%;
			background: linear-gradient(90deg, #52c41a, #73d13d);
			animation: progressFill 2s ease-in-out;
		}

		/* 导入成功通知样式 */
		.import-success-notification {
			border-radius: 12px !important;
			box-shadow: 0 4px 20px rgba(82, 196, 26, 0.3) !important;
			border: 1px solid #b7eb8f !important;
		}

		.import-success-notification .el-notification__title {
			color: #52c41a;
			font-weight: 600;
		}

		/* 导入过程中的进度条 */
		.import-progress-container {
			margin: 20px 0;
		}

		.import-progress-container .el-progress__text {
			font-size: 14px;
			color: #409EFF;
			font-weight: 500;
		}

		/* 文件上传区域的加载状态 */
		.file-upload-area.loading {
			position: relative;
		}

		.file-upload-area.loading::before {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background: rgba(255, 255, 255, 0.8);
			z-index: 1;
			border-radius: 10px;
		}

		.file-upload-area.loading::after {
			content: '';
			position: absolute;
			top: 50%;
			left: 50%;
			width: 40px;
			height: 40px;
			margin: -20px 0 0 -20px;
			border: 3px solid #f3f3f3;
			border-top: 3px solid #409EFF;
			border-radius: 50%;
			animation: spin 1s linear infinite;
			z-index: 2;
		}

		/* 动画定义 */
		@keyframes rotate {
			from {
				transform: rotate(0deg);
			}

			to {
				transform: rotate(360deg);
			}
		}

		@keyframes spin {
			0% {
				transform: rotate(0deg);
			}

			100% {
				transform: rotate(360deg);
			}
		}

		@keyframes scaleIn {
			0% {
				transform: scale(0);
				opacity: 0;
			}

			70% {
				transform: scale(1.2);
				opacity: 1;
			}

			100% {
				transform: scale(1);
			}
		}

		@keyframes pulse {
			0% {
				transform: scale(1);
				opacity: 1;
			}

			50% {
				transform: scale(1.05);
				opacity: 0.9;
			}

			100% {
				transform: scale(1);
				opacity: 1;
			}
		}

		@keyframes progressFill {
			0% {
				width: 0%;
				opacity: 0;
			}

			100% {
				width: 100%;
				opacity: 1;
			}
		}

		@keyframes fadeInUp {
			from {
				opacity: 0;
				transform: translateY(20px);
			}

			to {
				opacity: 1;
				transform: translateY(0);
			}
		}

		@keyframes bounce {

			0%,
			100% {
				transform: translateY(0);
			}

			50% {
				transform: translateY(-10px);
			}
		}

		/* 导入按钮的呼吸灯效果 */
		.dialog-btn.import-btn:not(.is-disabled):not(.is-loading) {
			animation: breathe 2s ease-in-out infinite;
		}

		@keyframes breathe {

			0%,
			100% {
				box-shadow: 0 2px 6px rgba(102, 126, 234, 0.2);
			}

			50% {
				box-shadow: 0 2px 12px rgba(102, 126, 234, 0.4);
			}
		}

		/* 响应式调整 */
		@media (max-width: 768px) {
			.import-confirm-content .confirm-details {
				padding: 10px;
			}

			.import-confirm-content .confirm-details p {
				font-size: 13px;
				margin: 6px 0;
			}

			.success-checkmark {
				font-size: 50px;
			}

			.success-text h3 {
				font-size: 16px;
			}
		}

		/* 导入进度消息样式 */
		.import-progress-message {
			background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
			color: white !important;
			border: none !important;
		}

		.import-progress-message .el-message__content {
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.import-progress-message .el-message__content::before {
			content: '';
			display: inline-block;
			width: 16px;
			height: 16px;
			border: 2px solid rgba(255, 255, 255, 0.3);
			border-top-color: white;
			border-radius: 50%;
			margin-right: 8px;
			animation: spin 1s linear infinite;
		}

		/* 导入确认弹窗样式 */
		.import-confirm-dialog .el-message-box {
			border-radius: 16px;
			overflow: hidden;
			border: 1px solid #e4e7ed;
		}

		.import-confirm-dialog .el-message-box__header {
			display: none;
			/* 隐藏默认标题 */
		}

		.import-confirm-dialog .el-message-box__content {
			padding: 0;
		}

		.import-confirm-container {
			padding: 24px;
		}

		.confirm-header {
			text-align: center;
			margin-bottom: 20px;
		}

		.warning-icon {
			font-size: 48px;
			color: #e6a23c;
			margin-bottom: 12px;
			display: block;
		}

		.confirm-title {
			font-size: 20px;
			font-weight: 600;
			color: #333;
			margin: 0;
		}

		.confirm-content {
			text-align: center;
		}

		.confirm-text {
			font-size: 16px;
			color: #666;
			margin-bottom: 24px;
			line-height: 1.5;
		}

		.import-details {
			background: linear-gradient(135deg, #f8f9ff 0%, #f0f2ff 100%);
			border-radius: 12px;
			padding: 20px;
			border: 1px solid #e6e8ff;
			margin-top: 16px;
		}

		.detail-item {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 12px;
			padding-bottom: 12px;
			border-bottom: 1px dashed #e4e7ed;
		}

		.detail-item:last-child {
			margin-bottom: 0;
			padding-bottom: 0;
			border-bottom: none;
		}

		.detail-label {
			font-size: 14px;
			color: #666;
			font-weight: 500;
		}

		.detail-value {
			font-size: 15px;
			color: #667eea;
			font-weight: 600;
		}

		/* 按钮样式 - 使用主题色 */
		.import-confirm-dialog .el-button {
			height: 44px !important;
			padding: 0 32px !important;
			font-size: 14px !important;
			font-weight: 600 !important;
			border-radius: 10px !important;
			border: none !important;
			transition: all 0.3s ease !important;
		}

		.import-confirm-dialog .el-button--cancel {
			background: #f5f5f5 !important;
			color: #666 !important;
		}

		.import-confirm-dialog .el-button--cancel:hover {
			background: #e8e8e8 !important;
			color: #333 !important;
			transform: translateY(-2px) !important;
			box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
		}

		.import-confirm-dialog .el-button--primary {
			background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
			color: #fff !important;
			box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3) !important;
		}

		.import-confirm-dialog .el-button--primary:hover {
			background: linear-gradient(135deg, #5a6fd8 0%, #6a4390 100%) !important;
			transform: translateY(-2px) !important;
			box-shadow: 0 4px 16px rgba(102, 126, 234, 0.4) !important;
		}

		/* 加载状态的按钮 */
		.import-confirm-dialog .el-button--primary.loading {
			position: relative;
			overflow: hidden;
		}

		.import-confirm-dialog .el-button--primary.loading::after {
			content: '';
			position: absolute;
			top: 50%;
			left: 50%;
			width: 20px;
			height: 20px;
			margin: -10px 0 0 -10px;
			border: 2px solid rgba(255, 255, 255, 0.3);
			border-top-color: #fff;
			border-radius: 50%;
			animation: spin 1s linear infinite;
		}

		.import-confirm-dialog .el-button--primary.loading span {
			visibility: hidden;
		}

		/* 响应式调整 */
		@media (max-width: 768px) {
			.import-confirm-container {
				padding: 20px;
			}

			.warning-icon {
				font-size: 40px;
			}

			.confirm-title {
				font-size: 18px;
			}

			.confirm-text {
				font-size: 14px;
				margin-bottom: 20px;
			}

			.import-details {
				padding: 16px;
			}

			.detail-label {
				font-size: 13px;
			}

			.detail-value {
				font-size: 14px;
			}

			.import-confirm-dialog .el-button {
				height: 40px !important;
				padding: 0 24px !important;
				font-size: 13px !important;
			}
		}

		/* 确保导入结果弹窗显示正常 */
		.import-result-dialog {
			z-index: 9999 !important;
		}

		.import-result-dialog .el-message-box {
			width: 80% !important;
			max-width: 800px !important;
		}

		.import-result-dialog .el-message-box__content {
			max-height: 500px;
			overflow-y: auto;
			padding: 20px;
		}

		/* 导入结果弹窗样式 */
		.import-result-detail-dialog .el-message-box {
			width: 800px !important;
			max-width: 90vw !important;
			border-radius: 12px;
			overflow: hidden;
			box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
		}

		.import-result-detail-dialog .el-message-box__header {
			background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
			padding: 16px 20px;
		}

		.import-result-detail-dialog .el-message-box__title {
			color: white;
			font-size: 18px;
			font-weight: 600;
		}

		.import-result-detail-dialog .el-message-box__headerbtn .el-icon-close {
			color: white;
			font-size: 20px;
		}

		.import-result-detail-dialog .el-message-box__content {
			padding: 0;
			max-height: 70vh;
			overflow-y: auto;
		}

		/* 物流单号表格样式 */
		.import-result-detail-dialog table {
			width: 100%;
			border-collapse: collapse;
		}

		.import-result-detail-dialog table th {
			background: #f0f9ff;
			color: #096dd9;
			font-weight: 600;
			text-align: left;
			padding: 10px;
			border-bottom: 2px solid #91d5ff;
			position: sticky;
			top: 0;
		}

		.import-result-detail-dialog table td {
			padding: 10px;
			border-bottom: 1px solid #f0f0f0;
		}

		.import-result-detail-dialog table tr:hover {
			background-color: #f8f9ff;
		}

		/* 操作按钮区域 */
		.import-result-detail-dialog .el-button--primary {
			background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
			border: none !important;
			color: white !important;
			padding: 10px 24px !important;
			border-radius: 8px !important;
			font-weight: 500 !important;
			transition: all 0.3s ease !important;
		}

		.import-result-detail-dialog .el-button--primary:hover {
			background: linear-gradient(135deg, #5a6fd8 0%, #6a4390 100%) !important;
			transform: translateY(-2px);
			box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
		}

		.import-result-detail-dialog .el-button--default {
			background: #f5f5f5 !important;
			border: 1px solid #e4e7ed !important;
			color: #666 !important;
			padding: 10px 24px !important;
			border-radius: 8px !important;
			font-weight: 500 !important;
		}

		.import-result-detail-dialog .el-button--default:hover {
			background: #e8e8e8 !important;
			border-color: #dcdfe6 !important;
			color: #333 !important;
		}

		/* 查看全部物流单号弹窗 */
		.all-track-numbers-dialog .el-message-box {
			width: 700px !important;
			max-width: 90vw !important;
		}

		.all-track-numbers-dialog .el-message-box__content {
			max-height: 500px;
			overflow-y: auto;
		}

		/* 轨迹结果详情弹窗样式 */
		.track-result-detail-dialog .el-message-box {
			border-radius: 12px;
			overflow: hidden;
			max-width: 700px;
		}

		.track-result-detail-dialog .el-message-box__header {
			background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
			padding: 20px;
			border-bottom: none;
		}

		.track-result-detail-dialog .el-message-box__title {
			color: #fff;
			font-size: 16px;
			font-weight: 600;
		}

		.track-result-detail-dialog .el-message-box__headerbtn .el-message-box__close {
			color: #fff;
		}

		.track-result-detail-dialog .el-message-box__content {
			padding: 20px;
			max-height: 60vh;
			overflow-y: auto;
		}

		.track-result-detail-dialog .el-message-box__btns {
			padding: 15px 20px;
			border-top: 1px solid #f0f0f0;
		}

		/* 旋转动画 */
		@keyframes rotating {
			from {
				transform: rotate(0deg);
			}

			to {
				transform: rotate(360deg);
			}
		}

		/* 表格样式优化 */
		.track-result-detail-dialog table {
			width: 100%;
			border-collapse: collapse;
			font-size: 12px;
		}

		.track-result-detail-dialog th {
			font-weight: 600;
			text-align: left;
			padding: 8px;
			background: #f5f5f5;
			border-bottom: 1px solid #e8e8e8;
		}

		.track-result-detail-dialog td {
			padding: 8px;
			border-bottom: 1px solid #f0f0f0;
		}

		/* 滚动条样式 */
		.track-result-detail-dialog .el-message-box__content::-webkit-scrollbar {
			width: 6px;
		}

		.track-result-detail-dialog .el-message-box__content::-webkit-scrollbar-track {
			background: #f1f1f1;
			border-radius: 3px;
		}

		.track-result-detail-dialog .el-message-box__content::-webkit-scrollbar-thumb {
			background: #c1c1c1;
			border-radius: 3px;
		}

		.track-result-detail-dialog .el-message-box__content::-webkit-scrollbar-thumb:hover {
			background: #a8a8a8;
		}

		/* 充值弹窗样式 */
		.beautiful-recharge-dialog .el-message-box {
			width: 600px;
			border-radius: 16px;
			overflow: hidden;
			box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
		}

		.beautiful-recharge-dialog .el-message-box__header {
			padding: 0;
			background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
		}

		.beautiful-recharge-dialog .el-message-box__content {
			padding: 0;
		}

		.beautiful-recharge-dialog .el-message-box__btns {
			padding: 20px;
			border-top: 1px solid #f0f0f0;
			display: flex;
			justify-content: space-between;
		}

		.beautiful-recharge-dialog .el-button--primary {
			background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
			border: none;
			border-radius: 8px;
			padding: 10px 24px;
		}

		.beautiful-recharge-dialog .el-button--default {
			background: #f5f5f5;
			color: #666;
			border: 1px solid #e4e7ed;
			border-radius: 8px;
			padding: 10px 24px;
		}

		/* 充值套餐网格 */
		.plans-grid {
			display: grid;
			grid-template-columns: repeat(3, 1fr);
			gap: 15px;
		}

		/* 套餐卡片 */
		.plan-card {
			position: relative;
			background: white;
			border: 2px solid #e4e7ed;
			border-radius: 12px;
			padding: 20px 15px;
			text-align: center;
			transition: all 0.3s ease;
		}

		.plan-card:hover {
			border-color: #667eea;
			transform: translateY(-3px);
			box-shadow: 0 6px 20px rgba(102, 126, 234, 0.15);
		}

		.plan-card.popular {
			border-color: #FFD700;
			background: linear-gradient(135deg, #fff9e6 0%, #fff4cc 100%);
		}

		/* 热销徽章 */
		.popular-badge {
			position: absolute;
			top: -10px;
			left: 50%;
			transform: translateX(-50%);
			background: linear-gradient(135deg, #FF6B6B 0%, #FF8E8E 100%);
			color: white;
			font-size: 12px;
			font-weight: 600;
			padding: 4px 12px;
			border-radius: 10px;
			box-shadow: 0 3px 8px rgba(255, 107, 107, 0.3);
		}

		/* 金额显示 */
		.plan-amount {
			margin-bottom: 12px;
		}

		.currency {
			font-size: 18px;
			color: #ff6b6b;
			font-weight: 600;
		}

		.amount-number {
			font-size: 32px;
			font-weight: 700;
			color: #333;
			margin-left: 2px;
		}

		/* 套餐详情 */
		.plan-details {
			margin-bottom: 15px;
		}

		.plan-points {
			font-size: 14px;
			color: #666;
			margin-bottom: 6px;
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 5px;
		}

		.plan-discount {
			display: inline-block;
			background: linear-gradient(135deg, #00C48C 0%, #00E6A9 100%);
			color: white;
			font-size: 12px;
			padding: 3px 8px;
			border-radius: 10px;
			font-weight: 500;
		}

		/* 兑换按钮 */
		.plan-value {
			background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
			color: white;
			font-size: 13px;
			font-weight: 500;
			padding: 8px 0;
			border-radius: 6px;
			transition: all 0.3s ease;
		}

		.plan-card:hover .plan-value {
			background: linear-gradient(135deg, #5a6fd8 0%, #6a4390 100%);
		}

		.plan-card.popular .plan-value {
			background: linear-gradient(135deg, #FFB800 0%, #FFD700 100%);
		}

		/* 确认弹窗 */
		.confirm-recharge-dialog .el-message-box {
			width: 400px;
			border-radius: 16px;
		}

		/* 使用深度选择器设置立即支付按钮样式 */
		.confirm-recharge-dialog>>>.el-button--primary {
			background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
			border: none !important;
			border-radius: 25px !important;
			/* 圆角效果 */
			color: white !important;
			font-weight: 600 !important;
			font-size: 14px !important;
			height: 46px !important;
			width: 140px !important;
			/* 固定宽度 */
			padding: 0 !important;
			transition: all 0.3s ease !important;
			box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3) !important;
		}

		/* 悬停效果 */
		.confirm-recharge-dialog>>>.el-button--primary:hover:not(.is-disabled):not(.is-loading) {
			background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%) !important;
			transform: translateY(-2px) !important;
			box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4) !important;
		}


		/* 响应式调整 */
		@media (max-width: 768px) {
			.beautiful-recharge-dialog .el-message-box {
				width: 90%;
				margin: 0 auto;
			}

			.plans-grid {
				grid-template-columns: repeat(2, 1fr);
				gap: 10px;
			}

			.amount-number {
				font-size: 28px;
			}
		}

		@media (max-width: 480px) {
			.plans-grid {
				grid-template-columns: 1fr;
			}
		}

		/* 简单充值弹窗样式 */
		.simple-recharge-dialog .el-message-box {
			border-radius: 20px;
			overflow: hidden;
			box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
			border: none;
		}

		.simple-recharge-dialog .el-message-box__header {
			display: none;
		}

		.simple-recharge-dialog .el-message-box__content {
			padding: 0;
		}

		.simple-recharge-dialog .el-message-box__btns {
			padding: 20px;
			background: #fafafa;
			border-top: 1px solid #f0f0f0;
		}

		.simple-recharge-dialog .el-button--primary {
			background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
			border: none;
			border-radius: 10px;
			padding: 12px 30px;
			font-weight: 600;
			font-size: 14px;
			transition: all 0.3s ease;
		}

		.simple-recharge-dialog .el-button--primary:hover {
			transform: translateY(-2px);
			box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
		}

		.simple-recharge-dialog .el-button--default {
			background: #f5f5f5;
			color: #666;
			border: 1px solid #e4e7ed;
			border-radius: 10px;
			padding: 12px 30px;
			font-weight: 600;
			font-size: 14px;
			transition: all 0.3s ease;
		}

		.simple-recharge-dialog .el-button--default:hover {
			background: #e8e8e8;
			transform: translateY(-2px);
		}

		/* 套餐卡片悬停效果 */
		.plan-card {
			position: relative;
			cursor: pointer;
			background: white;
			border: 2px solid #e4e7ed;
			border-radius: 12px;
			padding: 20px 15px;
			text-align: center;
			transition: all 0.3s ease;
		}

		.plan-card:hover {
			border-color: #667eea;
			transform: translateY(-5px);
			box-shadow: 0 10px 30px rgba(102, 126, 234, 0.2);
		}

		.plan-card:hover .plan-action {
			transform: scale(1.05);
		}

		.plan-card.popular {
			border-color: #FFD700;
			background: linear-gradient(135deg, #fff9e6 0%, #fff4cc 100%);
		}

		.plan-card.popular:hover {
			box-shadow: 0 10px 30px rgba(255, 184, 0, 0.2);
		}

		/* 响应式调整 */
		@media (max-width: 768px) {
			.simple-recharge-dialog {
				width: 95% !important;
			}

			.plans-grid {
				grid-template-columns: repeat(2, 1fr) !important;
				gap: 12px !important;
			}

			.large-amount-option .flex-container {
				flex-direction: column !important;
			}
		}

		@media (max-width: 480px) {
			.plans-grid {
				grid-template-columns: 1fr !important;
			}

			.recharge-info .grid-container {
				grid-template-columns: 1fr !important;
			}
		}

		.simple-recharge-dialog {
			width: auto;
			height: auto;
		}

		.el-message-box__wrapper {
			overflow: auto;
		}

		.note-card {
			background-color: #fff5f7;
			border-left: 4px solid #ff4d5a;
			border-radius: 12px;
			padding: 32px 24px;
			font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
			max-width: 100%;
			line-height: 1.8;
		}

		.note-card p {
			font-size: 12px;
			color: #4a5568;
			margin: 16px 0;
		}

		.code-inline {
			background-color: #f0f4ff;
			color: #2b3890;
			padding: 4px 8px;
			border-radius: 6px;
			font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
			font-size: 0.9em;
		}

		.highlight {
			font-weight: 600;
			color: #2d3748;
		}
	</style>